const DEPARTMENT_OPTIONS = [
    "AMAZONAS",
    "ANTIOQUIA",
    "ARAUCA",
    "ARCHIPIELAGO DE SAN ANDRES",
    "ATLANTICO",
    "BOGOTA D.C.",
    "BOLIVAR",
    "BOYACA",
    "CALDAS",
    "CAQUETA",
    "CASANARE",
    "CAUCA",
    "CESAR",
    "CHOCO",
    "CORDOBA",
    "CUNDINAMARCA",
    "GUAINIA",
    "GUAVIARE",
    "HUILA",
    "LA GUAJIRA",
    "MAGDALENA",
    "META",
    "NARIÑO",
    "NORTE DE SANTANDER",
    "PUTUMAYO",
    "QUINDIO",
    "RISARALDA",
    "SANTANDER",
    "SUCRE",
    "TOLIMA",
    "VALLE DEL CAUCA",
    "VAUPES",
    "VICHADA",
  ];
  
  const CITY_OPTIONS = [
    "ABEJORRAL", "ABREGO", "ABRIAQUI", "ACACiAS", "ACANDI", "ACEVEDO", "ACHI", "AGRADO", "AGUA DE DIOS", "AGUACHICA",
    "AGUADA", "AGUADAS", "AGUAZUL", "AGUSTIN CODAZZI", "AIPE", "ALBAN", "ALBANIA", "ALCALa", "ALDANA", "ALEJANDRIA",
    "ALGARROBO", "ALGECIRAS", "ALMAGUER", "ALMEIDA", "ALPUJARRA", "ALTAMIRA", "ALTO BAUDO", "ALTOS DEL ROSARIO", "ALVARADO", "AMAGa",
    "AMALFI", "AMBALEMA", "ANAPOIMA", "ANCUYA", "ANDALUCIA", "ANDES", "ANGELOPOLIS", "ANGOSTURA", "ANOLAIMA", "ANORI",
    "ANSERMA", "ANSERMANUEVO", "ANZA", "ANZOATEGUI", "APARTADO", "APIA", "APULO", "AQUITANIA", "ARACATACA", "ARANZAZU",
    "ARAUCA", "ARATOCA", "ARAUQUITA", "ARBELAEZ", "ARBOLEDA", "ARBOLEDAS", "ARBOLETES", "ARCABUCO", "ARENAL", "ARGELIA", "ARIGUANI",
    "ARJONA", "ARMENIA", "ARMERO", "ARROYOHONDO", "ASTREA", "ATACO", "ATRATO", "AYAPEL", "BAGADO", "BAHIA SOLANO",
    "BAJO BAUDO", "BALBOA", "BARANOA", "BARAYA", "BARBACOAS", "BARBOSA", "BARICHARA", "BARRANCA DE UPIA", "BARRANCABERMEJA", "BARRANCAS",
    "BARRANCO DE LOBA", "BARRANCO MINA", "BARRANQUILLA", "BECERRIL", "BELALCAZAR", "BELEN DE BAJIRA", "BELEN DE LOS ANDAQUIES", "BELEN DE UMBRIA", "BELEN", "BELLO",
    "BELMIRA", "BELTRAN", "BERBEO", "BETANIA", "BETEITIVA", "BETULIA", "BITUIMA", "BOAVITA", "BOCHALEMA", "BOGOTA D.C.", "BOJACA",
    "BOJAYA", "BOLIVAR", "BOSCONIA", "BOYACA", "BRICENO", "BUCARAMANGA", "BUCARASICA", "BUENAVENTURA", "BUENAVISTA", "BUENOS AIRES", "BUESACO", "BUGA",
    "BUGALAGRANDE", "BURITICA", "BUSBANZA", "CABRERA", "CABUYARO", "CACAHUAL", "CACERES", "CACHIPAY", "CACHIRA", "CACOTA",
    "CAICEDO", "CAICEDONIA", "CAIMITO", "CAJAMARCA", "CAJIBIO", "CAJICA", "CALAMAR", "CALARCA", "CALDAS", "CALDONO", "CALI",
    "CALIFORNIA", "CALIMA", "CALOTO", "CAMPAMENTO", "CAMPO DE LA CRUZ", "CAMPOALEGRE", "CAMPOHERMOSO", "CANALETE", "CANASGORDAS", "CANDELARIA",
    "CANTAGALLO", "CANTON DE SAN PABLO", "CAPARRAPI", "CAPITANEJO", "CAQUEZA", "CARACOLI", "CARAMANTA", "CARCASI", "CAREPA", "CARMEN DE APICALA",
    "CARMEN DE BOLIVAR", "CARMEN DE CARUPA", "CARMEN DE VIBORAL", "CARMEN DEL DARIEN", "CAROLINA", "CARTAGENA DEL CHAIRA", "CARTAGENA", "CARTAGO", "CARURU", "CASABIANCA", "CASTILLA LA NUEVA", "CAUCASIA",
    "CEPITA", "CERETE", "CERINZA", "CERRITO", "CERRO SAN ANTONIO", "CERTEGUI", "CHACHAGUI", "CHAGUANI", "CHALAN", "CHAMEZA",
    "CHAPARRAL", "CHARALA", "CHARTA", "CHIA", "CHIBOLO", "CHIGORODO", "CHIMA", "CHIMICHAGUA", "CHINACOTA", "CHINAVITA",
    "CHINCHINa", "CHINU", "CHIPAQUE", "CHIPATA", "CHIQUINQUIRA", "CHIQUIZA", "CHIRIGUANA", "CHISCAS", "CHITA", "CHITAGA",
    "CHITARAQUE", "CHIVATA", "CHIVOR", "CHOACHI", "CHOCONTA", "CICUCO", "CIENAGA DE ORO", "CIENAGA", "CIENEGA", "CIMITARRA", "CIRCASIA",
    "CISNEROS", "CIUDAD BOLIVAR", "CLEMENCIA", "COCORNA", "COELLO", "COGUA", "COLOMBIA", "COLON", "COLOSO", "COMBITA", "CONCEPCION",
    "CONCORDIA", "CONDOTO", "CONFINES", "CONSACA", "CONTADERO", "CONTRATACION", "CONVENCION", "COPACABANA", "COPER", "CORDOBA", "CORINTO",
    "COROMORO", "COROZAL", "CORRALES", "COTA", "COTORRA", "COVARACHIA", "COVENAS", "COYAIMA", "CRAVO NORTE", "CUASPUD",
    "CUBARA", "CUCAITA", "CUCUNUBA", "CUCUTA", "CUCUTILLA", "CUITIVA", "CUMARAL", "CUMARIBO", "CUMBAL", "CUMBITARA",
    "CUNDAY", "CURITI", "CURRILLO", "CURUMANI", "CoRDOBA", "DABEIBA", "DAGUA", "DIBULLA", "DISTRACCION", "DOLORES",
    "DON MATiAS", "DOSQUEBRADAS", "DUITAMA", "DURANIA", "EBEJICO", "EL AGUILA", "EL BAGRE", "EL BANCO", "EL CAIRO", "EL CALVARIO",
    "EL CARMEN DE ATRATO", "EL CARMEN DE CHUCURI", "EL CARMEN", "EL CASTILLO", "EL CERRITO", "EL CHARCO", "EL COCUY", "EL COLEGIO", "EL COPEY", "EL DONCELLO",
    "EL DORADO", "EL DOVIO", "EL ENCANTO", "EL ESPINO", "EL GUACAMAYO", "EL GUAMO", "EL MOLINO", "EL PASO", "EL PAUJIL", "EL PENOL",
    "EL PENON", "EL PINON", "EL PLAYON", "EL RETEN", "EL RETORNO", "EL ROBLE", "EL ROSAL", "EL ROSARIO", "EL TAMBO", "EL TARRA",
    "EL ZULIA", "ELIAS", "ENCINO", "ENCISO", "ENTRERRIOS", "ENVIGADO", "ESPINAL", "El Litoral del San Juan", "El Tablon de Gomez", "FACATATIVA",
    "FALAN", "FILADELFIA", "FILANDIA", "FIRAVITOBA", "FLANDES", "FLORENCIA", "FLORESTA", "FLORIAN", "FLORIDA", "FLORIDABLANCA",
    "FOMEQUE", "FONSECA", "FORTUL", "FOSCA", "FRANCISCO PIZARRO", "FREDONIA", "FRESNO", "FRONTINO", "FUENTE DE ORO", "FUNDACION",
    "FUNES", "FUNZA", "FUQUENE", "FUSAGASUGA", "GACHALA", "GACHANCIPA", "GACHANTIVA", "GACHETA", "GALAN", "GALAPA",
    "GALERAS", "GAMA", "GAMARRA", "GAMBITA", "GAMEZA", "GARAGOA", "GARZON", "GIGANTE", "GINEBRA", "GIRALDO",
    "GIRARDOT", "GIRARDOTA", "GIRON", "GOMEZ PLATA", "GONZALEZ", "GRAMALOTE", "GRANADA", "GUACA", "GUACAMAYAS", "GUACARI",
    "GUACHETA", "GUACHUCAL", "GUADALUPE", "GUADUAS", "GUAITARILLA", "GUALMATAN", "GUAMAL", "GUAMO", "GUAPI", "GUAPOTA",
    "GUARANDA", "GUARNE", "GUASCA", "GUATAPE", "GUATAQUI", "GUATAVITA", "GUATEQUE", "GUATICA", "GUAVATA", "GUAYABAL DE SIQUIMA",
    "GUAYABETAL", "GUAYATA", "GUTIERREZ", "GeNOVA", "GuEPSA", "GÜICAN", "HACARI", "HATILLO DE LOBA", "HATO COROZAL", "HATO",
    "HATONUEVO", "HELICONIA", "HERRAN", "HERVEO", "HISPANIA", "HOBO", "HONDA", "IBAGUe", "ICONONZO", "ILES",
    "IMUES", "INIRIDA", "INZA", "IPIALES", "IQUIRA", "ISNOS", "ITAGUI", "ITSMINA", "ITUANGO", "IZA",
    "JAMBALO", "JAMUNDI", "JARDIN", "JENESANO", "JERICO", "JERUSALEN", "JESUS MARIA", "JORDAN", "JUAN DE ACOSTA", "JUNIN",
    "JURADO", "LA APARTADA", "LA ARGENTINA", "LA BELLEZA", "LA CALERA", "LA CAPILLA", "LA CEJA", "LA CELIA", "LA CHORRERA", "LA CRUZ",
    "LA CUMBRE", "LA DORADA", "LA ESPERANZA", "LA ESTRELLA", "LA FLORIDA", "LA GLORIA", "LA GUADALUPE", "LA JAGUA DE IBIRICO", "LA JAGUA DEL PILAR", "LA LLANADA",
    "LA MACARENA", "LA MERCED", "LA MESA", "LA MONTANITA", "LA PALMA", "LA PAZ", "LA PEDRERA", "LA PENA", "LA PINTADA", "LA PLATA",
    "LA PLAYA", "LA PRIMAVERA", "LA SALINA", "LA SIERRA", "LA TEBAIDA", "LA TOLA", "LA UNION", "LA URIBE", "LA UVITA", "LA VEGA",
    "LA VICTORIA", "LA VIRGINIA", "LABATECA", "LABRANZAGRANDE", "LANDAZURI", "LEBRIJA", "LEIVA", "LEJANIAS", "LENGUAZAQUE", "LETICIA", "LIBORINA",
    "LINARES", "LLORO", "LOPEZ", "LORICA", "LOS ANDES", "LOS CORDOBAS", "LOS PALMITOS", "LOS PATIOS", "LOS SANTOS", "LOURDES", "LURUACO",
    "LeRIDA", "LiBANO", "MACANAL", "MACARAVITA", "MACEO", "MACHETA", "MADRID", "MAGANGUE", "MAHATES", "MAICAO",
    "MAJAGUAL", "MALAGA", "MALAMBO", "MALLAMA", "MANATi", "MANAURE", "MANI", "MANIZALES", "MANTA", "MANZANARES",
    "MAPIRIPaN", "MARGARITA", "MARIA LA BAJA", "MARINILLA", "MARIPI", "MARIQUITA", "MARMATO", "MARQUETALIA", "MARSELLA", "MARULANDA",
    "MATANZA", "MEDELLIN", "MEDINA", "MEDIO ATRATO", "MEDIO BAUDO", "MEDIO SAN JUAN", "MELGAR", "MERCADERES", "MESETAS", "MILaN",
    "MIRAFLORES", "MIRANDA", "MIRITI - PARANA", "MISTRATO", "MITU", "MOCOA", "MOGOTES", "MOLAGAVITA", "MOMIL", "MOMPOS",
    "MONGUA", "MONGUI", "MONIQUIRA", "MONITOS", "MONTEBELLO", "MONTECRISTO", "MONTELIBANO", "MONTERIA", "MONTERREY", "MORALES",
    "MORELIA", "MORICHAL", "MORROA", "MOSQUERA", "MOTAVITA", "MURILLO", "MURINDO", "MUTATA", "MUTISCUA", "MUZO",
    "Magui", "Montengro", "NARINO", "NATAGA", "NATAGAIMA", "NECHI", "NECOCLI", "NEIRA", "NEIVA", "NEMOCoN",
    "NILO", "NIMAIMA", "NOBSA", "NOCAIMA", "NORCASIA", "NOVITA", "NUEVA GRANADA", "NUEVO COLON", "NUNCHIA", "NUQUI",
    "OBANDO", "OCAMONTE", "OCANA", "OIBA", "OICATA", "OLAYA HERRERA", "OLAYA", "ONZAGA", "OPORAPA", "ORITO",
    "OROCUE", "ORTEGA", "OSPINA", "OTANCHE", "OVEJAS", "PACHAVITA", "PACHO", "PACOA", "PACORA", "PADILLA",
    "PAEZ", "PAICOL", "PAILITAS", "PAIME", "PAIPA", "PAJARITO", "PALERMO", "PALESTINA", "PALMAR DE VARELA", "PALMAR",
    "PALMAS DEL SOCORRO", "PALMIRA", "PALMITO", "PALOCABILDO", "PAMPLONA", "PAMPLONITA", "PANA PANA", "PANDI", "PANQUEBA", "PAPUNAHUA",
    "PARAMO", "PARATEBUENO", "PASCA", "PASTO", "PATIA", "PAUNA", "PAYA", "PAZ DE ARIPORO", "PAZ DE RIO", "PEDRAZA",
    "PELAYA", "PENOL", "PENSILVANIA", "PEQUE", "PEREIRA", "PESCA", "PIAMONTE", "PIEDECUESTA", "PIEDRAS", "PIENDAMO",
    "PIJAO", "PIJINO DEL CARMEN", "PINCHOTE", "PINILLOS", "PIOJO", "PISBA", "PITAL", "PITALITO", "PIVIJAY", "PLANADAS",
    "PLANETA RICA", "PLATO", "POLICARPA", "POLONUEVO", "PONEDERA", "POPAYAN", "PORE", "POTOSI", "PRADERA", "PRADO",
    "PROVIDENCIA Y SANTA CATALINA", "PROVIDENCIA", "PUEBLO BELLO", "PUEBLO NUEVO", "PUEBLO RICO", "PUEBLO VIEJO", "PUEBLORRICO", "PUENTE NACIONAL", "PUERRES", "PUERTO ALEGRIA",
    "PUERTO ARICA", "PUERTO ASIS", "PUERTO BERRiO", "PUERTO BOYACa", "PUERTO CAICEDO", "PUERTO CARRENO", "PUERTO COLOMBIA", "PUERTO CONCORDIA", "PUERTO ESCONDIDO", "PUERTO GAITAN",
    "PUERTO GUZMAN", "PUERTO LEGUIZAMO", "PUERTO LIBERTADOR", "PUERTO LLERAS", "PUERTO LoPEZ", "PUERTO NARE", "PUERTO NARINO", "PUERTO PARRA", "PUERTO RICO", "PUERTO RONDON",
    "PUERTO SALGAR", "PUERTO SANTANDER", "PUERTO TEJADA", "PUERTO TRIUNFO", "PUERTO WILCHES", "PULI", "PUPIALES", "PURACE", "PURIFICACION", "PURISIMA", "QUEBRADANEGRA",
    "QUETAME", "QUIBDO", "QUIMBAYA", "QUINCHiA", "QUIPAMA", "QUIPILE", "RAGONVALIA", "RAMIRIQUI", "RAQUIRA", "RECETOR",
    "REGIDOR", "REMEDIOS", "REMOLINO", "REPELON", "RESTREPO", "RETIRO", "RICAURTE", "RIO DE ORO", "RIO FRIO", "RIO QUITO",
    "RIO VIEJO", "RIOBLANCO", "RIOFRIO", "RIOHACHA", "RIONEGRO", "RIOSUCIO", "RISARALDA", "RIVERA", "ROBERTO PAYAN", "ROLDANILLO", "RONCESVALLES",
    "RONDON", "ROSAS", "ROVIRA", "SABANA DE TORRES", "SABANALARGA", "SABANAS DE SAN ANGEL", "SABANETA", "SABOYA", "SACAMA", "SACHICA",
    "SAHAGUN", "SALADOBLANCO", "SALAMINA", "SALAZAR", "SALDANA", "SALENTO", "SALGAR", "SAMACA", "SAMANA", "SAMANIEGO",
    "SAMPUES", "SAN AGUSTIN", "SAN ALBERTO", "SAN ANDRES SOTAVENTO", "SAN ANDRES", "SAN ANDReS", "SAN ANTERO", "SAN ANTONIO DE TEQUENDAMA", "SAN ANTONIO", "SAN BENITO ABAD",
    "SAN BENITO", "SAN BERNARDO DEL VIENTO", "SAN BERNARDO", "SAN CALIXTO", "SAN CARLOS GUAROA", "SAN CARLOS", "SAN CAYETANO", "SAN CRISTOBAL", "SAN DIEGO", "SAN EDUARDO",
    "SAN ESTANISLAO", "SAN FELIPE", "SAN FERNANDO", "SAN FRANCISCO", "SAN GIL", "SAN JACINTO", "SAN JACINTO DEL CAUCA", "SAN JERONIMO", "SAN JOAQUIN", "SAN JOSE DE LA MONTANA", "SAN JOSE DE MIRANDA",
    "SAN JOSE DE PARE", "SAN JOSE DEL FRAGUA", "SAN JOSE DEL GUAVIARE", "SAN JOSE DEL PALMAR", "SAN JOSE", "SAN JUAN BETULIA", "SAN JUAN DE ARAMA", "SAN JUAN DE RIO SECO", "SAN JUAN DE URABA", "SAN JUAN DEL CESAR", "SAN JUAN NEPOMUCENO", "SAN JUANITO",
    "SAN LORENZO", "SAN LUIS DE CUBARRAL", "SAN LUIS DE GACENO", "SAN LUIS DE PALENQUE", "SAN LUIS", "SAN MARCOS", "SAN MARTIN DE LOBA", "SAN MARTIN", "SAN MATEO", "SAN MIGUEL DE SEMA",
    "SAN MIGUEL", "SAN ONOFRE", "SAN PABLO BORBUR", "SAN PABLO", "SAN PEDRO DE CARTAGO", "SAN PEDRO DE URABA", "SAN PEDRO", "SAN PELAYO", "SAN RAFAEL", "SAN ROQUE",
    "SAN ROSA VITERBO", "SAN SEBASTIAN DE BUENAVISTA", "SAN SEBASTIAN", "SAN VICENTE DE CHUCURI", "SAN VICENTE DEL CAGUAN", "SAN VICENTE", "SAN ZENON", "SANDONA", "SANTA ANA", "SANTA BARBARA DE PINTO",
    "SANTA BARBARA", "SANTA BaRBARA", "SANTA CATALINA", "SANTA CRUZ", "SANTA HELENA DEL OPON", "SANTA ISABEL", "SANTA LUCiA", "SANTA MARIA", "SANTA MARTA", "SANTA ROSA DE CABAL",
    "SANTA ROSA DE LIMA", "SANTA ROSA DEL SUR", "SANTA ROSA de osos", "SANTA ROSA", "SANTA ROSALIA", "SANTA SOFIA", "SANTANA", "SANTANDER DE QUILICHAO", "SANTAFE DE ANTIOQUIA", "SANTIAGO DE TOLU", "SANTIAGO", "SANTO DOMINGO",
    "SANTUARIO", "SAPUYES", "SARAVENA", "SARDINATA", "SASAIMA", "SATIVANORTE", "SATIVASUR", "SEGOVIA", "SESQUILE", "SEVILLA",
    "SIACHOQUE", "SIBATE", "SIBUNDOY", "SILOS", "SILVANIA", "SIMACOTA", "SIMIJACA", "SIMITI", "SINCE", "SINCELEJO",
    "SIPI", "SITIONUEVO", "SOACHA", "SOATA", "SOCHA", "SOCORRO", "SOCOTA", "SOGAMOSO", "SOLANO", "SOLEDAD",
    "SOLITA", "SOMONDOCO", "SONSON", "SOPETRaN", "SOPLAVIENTO", "SOPO", "SORA", "SORACA", "SOTAQUIRA", "SOTARA",
    "SUAITA", "SUAN", "SUAREZ", "SUAZA", "SUBACHOQUE", "SUCRE", "SUESCA", "SUPATA", "SUPIA", "SURATA", "SUSA",
    "SUSACON", "SUTAMARCHAN", "SUTATAUSA", "SUTATENZA", "Sabanagrande", "Santo Tomas", "Silvia", "TABIO", "TADO", "TALAIGUA NUEVO",
    "TAMALAMEQUE", "TAMARA", "TAME", "TAMESIS", "TAMINANGO", "TANGUA", "TARAIRA", "TARAPACA", "TARAZA", "TARQUI",
    "TARSO", "TASCO", "TAURAMENA", "TAUSA", "TELLO", "TENA", "TENERIFE", "TENJO", "TENZA", "TEORAMA",
    "TERUEL", "TESALIA", "TIBACUY", "TIBANA", "TIBASOSA", "TIBIRITA", "TIBU", "TIERRALTA", "TIMANA", "TIMBIO",
    "TIMBIQUI", "TINJACA", "TIPACOQUE", "TIQUISIO", "TITIRIBI", "TOCA", "TOCAIMA", "TOCANCIPA", "TOGÜI", "TOLEDO",
    "TOLU VIEJO", "TONA", "TOPAGA", "TOPAIPI", "TORIBIO", "TORO", "TOTA", "TOTORO", "TRINIDAD", "TRUJILLO",
    "TUBARA", "TULUA", "TUMACO", "TUNJA", "TUNUNGUA", "TUQUERRES", "TURBACO", "TURBANA", "TURBO", "TURMEQUE",
    "TUTA", "TUTAZA", "UBALA", "UBAQUE", "UBATE", "ULLOA", "UMBITA", "UNE", "UNGUIA", "UNION PANAMERICANA",
    "URAMITA", "URIBIA", "URRAO", "URUMITA", "USIACURi", "UTICA", "VALDIVIA", "VALENCIA", "VALLE DE SAN JOSE", "VALLE DE SAN JUAN",
    "VALLE DEL GUAMUEZ", "VALLEDUPAR", "VALPARAISO", "VEGACHI", "VELEZ", "VENADILLO", "VENECIA", "VENTAQUEMADA", "VERGARA", "VERSALLES",
    "VETAS", "VIANI", "VICTORIA", "VIGIA DEL FUERTE", "VIJES", "VILLA CARO", "VILLA DE LEYVA", "VILLA DEL ROSARIO", "VILLA GARZON", "VILLA RICA",
    "VILLAGOMEZ", "VILLAHERMOSA", "VILLAMARiA", "VILLANUEVA", "VILLAPINZON", "VILLARRICA", "VILLAVICENCIO", "VILLAVIEJA", "VILLETA", "VIOTA",
    "VIRACACHA", "VISTA HERMOSA", "VITERBO", "YACOPI", "YACUANQUER", "YAGUARA", "YALI", "YARUMAL", "YAVARATE", "YOLOMBO",
    "YONDO", "YOPAL", "YOTOCO", "YUMBO", "ZAMBRANO", "ZAPATOCA", "ZAPAYAN", "ZARAGOZA", "ZARZAL", "ZETAQUIRA",
    "ZIPACoN", "ZIPAQUIRA", "ZONA BANANERA",
  ];
  
  
  // Province codes for betterwaremarket API
  const DEPARTMENT_CODE_MAP = {
    "AMAZONAS": "AMA",
    "ANTIOQUIA": "ANT",
    "ARAUCA": "ARA",
    "ARCHIPIELAGO DE SAN ANDRES": "SAP",
    "ATLANTICO": "ATL",
    "BOGOTA D.C.": "DC",
    "BOLIVAR": "BOL",
    "BOYACA": "BOY",
    "CALDAS": "CAL",
    "CAQUETA": "CAQ",
    "CASANARE": "CAS",
    "CAUCA": "CAU",
    "CESAR": "CES",
    "CHOCO": "CHO",
    "CORDOBA": "COR",
    "CUNDINAMARCA": "CUN",
    "GUAINIA": "GUA",
    "GUAVIARE": "GUV",
    "HUILA": "HUI",
    "LA GUAJIRA": "LAG",
    "MAGDALENA": "MAG",
    "META": "MET",
    "NARIÑO": "NAR",
    "NORTE DE SANTANDER": "NSA",
    "PUTUMAYO": "PUT",
    "QUINDIO": "QUI",
    "RISARALDA": "RIS",
    "SANTANDER": "SAN",
    "SUCRE": "SUC",
    "TOLIMA": "TOL",
    "VALLE DEL CAUCA": "VAC",
    "VAUPES": "VAU",
    "VICHADA": "VID",
  };
  
  // Municipality codes tagged as SINCOB01 (no coverage) - these should be hidden from registration
  const EXCLUDED_MUNICIPALITY_CODES = new Set([
    "91263", "91405", "91407", "91460", "91530", "91536", "91798",
    "5107", "81220", "81591", "13650", "13062", "13620", "13580", "13458",
    "15232", "15762", "15522", "15533", "15550", "15090", "15660", "15621",
    "15879", "15774", "15106", "15212", "15832", "15380", "15226", "15822",
    "15162", "17446", "18479", "18785", "85136", "85279", "19760", "19022",
    "20310", "27050", "27073", "27099", "27413", "27425", "27600", "27150",
    "27372", "27495", "27025", "27250", "27430", "27135", "27160", "27450",
    "27491", "27580", "27660", "27745", "27810", "25324", "25086", "25793",
    "94343", "94886", "94885", "94888", "94887", "94883", "95025", "41378",
    "44420", "47030", "47541", "47605", "47960", "47703", "47720", "50245",
    "50686", "52788", "52435", "52699", "52520", "52390", "52621", "52051",
    "52405", "52224", "54313", "54680", "54871", "54250", "54670", "54125",
    "54347", "54377", "86219", "86760", "68524", "68425", "68686", "68370",
    "70233", "73152", "73870", "97161", "97511", "97777", "97666", "97889",
  ]);
  
  const _COLOMBIA_DEPARTMENTS_RAW =
  [
    {
      "name": "AMAZONAS",
      "cities": [
        {
          "name": "EL ENCANTO",
          "code": "91263"
        },
        {
          "name": "LA CHORRERA",
          "code": "91405"
        },
        {
          "name": "LA PEDRERA",
          "code": "91407"
        },
        {
          "name": "LA VICTORIA",
          "code": "91430"
        },
        {
          "name": "LETICIA",
          "code": "91001"
        },
        {
          "name": "MIRITI - PARANA",
          "code": "91460"
        },
        {
          "name": "PUERTO ALEGRIA",
          "code": "91530"
        },
        {
          "name": "PUERTO ARICA",
          "code": "91536"
        },
        {
          "name": "PUERTO NARINO",
          "code": "91540"
        },
        {
          "name": "PUERTO SANTANDER",
          "code": "91669"
        },
        {
          "name": "TARAPACA",
          "code": "91798"
        }
      ]
    },
    {
      "name": "ANTIOQUIA",
      "cities": [
        {
          "name": "ABEJORRAL",
          "code": "5002"
        },
        {
          "name": "ABRIAQUI",
          "code": "5004"
        },
        {
          "name": "ALEJANDRIA",
          "code": "5021"
        },
        {
          "name": "AMAGa",
          "code": "5030"
        },
        {
          "name": "AMALFI",
          "code": "5031"
        },
        {
          "name": "ANDES",
          "code": "5034"
        },
        {
          "name": "ANGELOPOLIS",
          "code": "5036"
        },
        {
          "name": "ANGOSTURA",
          "code": "5038"
        },
        {
          "name": "ANORI",
          "code": "5040"
        },
        {
          "name": "ANZA",
          "code": "5044"
        },
        {
          "name": "APARTADO",
          "code": "5045"
        },
        {
          "name": "ARBOLETES",
          "code": "5051"
        },
        {
          "name": "ARGELIA",
          "code": "5055"
        },
        {
          "name": "ARMENIA",
          "code": "5059"
        },
        {
          "name": "BARBOSA",
          "code": "5079"
        },
        {
          "name": "BELLO",
          "code": "5088"
        },
        {
          "name": "BELMIRA",
          "code": "5086"
        },
        {
          "name": "BETANIA",
          "code": "5091"
        },
        {
          "name": "BETULIA",
          "code": "5093"
        },
        {
          "name": "BRICENO",
          "code": "5107"
        },
        {
          "name": "BURITICA",
          "code": "5113"
        },
        {
          "name": "CACERES",
          "code": "5120"
        },
        {
          "name": "CAICEDO",
          "code": "5125"
        },
        {
          "name": "CALDAS",
          "code": "5129"
        },
        {
          "name": "CAMPAMENTO",
          "code": "5134"
        },
        {
          "name": "CANASGORDAS",
          "code": "5138"
        },
        {
          "name": "CARACOLI",
          "code": "5142"
        },
        {
          "name": "CARAMANTA",
          "code": "5145"
        },
        {
          "name": "CAREPA",
          "code": "5147"
        },
        {
          "name": "CARMEN DE VIBORAL",
          "code": "5148"
        },
        {
          "name": "CAROLINA",
          "code": "5150"
        },
        {
          "name": "CAUCASIA",
          "code": "5154"
        },
        {
          "name": "CHIGORODO",
          "code": "5172"
        },
        {
          "name": "CISNEROS",
          "code": "5190"
        },
        {
          "name": "CIUDAD BOLIVAR",
          "code": "5101"
        },
        {
          "name": "COCORNA",
          "code": "5197"
        },
        {
          "name": "CONCEPCION",
          "code": "5206"
        },
        {
          "name": "CONCORDIA",
          "code": "5209"
        },
        {
          "name": "COPACABANA",
          "code": "5212"
        },
        {
          "name": "DABEIBA",
          "code": "5234"
        },
        {
          "name": "DON MATiAS",
          "code": "5237"
        },
        {
          "name": "EBEJICO",
          "code": "5240"
        },
        {
          "name": "EL BAGRE",
          "code": "5250"
        },
        {
          "name": "ENTRERRIOS",
          "code": "5264"
        },
        {
          "name": "ENVIGADO",
          "code": "5266"
        },
        {
          "name": "FREDONIA",
          "code": "5282"
        },
        {
          "name": "FRONTINO",
          "code": "5284"
        },
        {
          "name": "GIRALDO",
          "code": "5306"
        },
        {
          "name": "GIRARDOTA",
          "code": "5308"
        },
        {
          "name": "GOMEZ PLATA",
          "code": "5310"
        },
        {
          "name": "GRANADA",
          "code": "5313"
        },
        {
          "name": "GUADALUPE",
          "code": "5315"
        },
        {
          "name": "GUARNE",
          "code": "5318"
        },
        {
          "name": "GUATAPE",
          "code": "5321"
        },
        {
          "name": "HELICONIA",
          "code": "5347"
        },
        {
          "name": "HISPANIA",
          "code": "5353"
        },
        {
          "name": "ITAGUI",
          "code": "5360"
        },
        {
          "name": "ITUANGO",
          "code": "5361"
        },
        {
          "name": "JARDIN",
          "code": "5364"
        },
        {
          "name": "JERICO",
          "code": "5368"
        },
        {
          "name": "LA CEJA",
          "code": "5376"
        },
        {
          "name": "LA ESTRELLA",
          "code": "5380"
        },
        {
          "name": "LA PINTADA",
          "code": "5390"
        },
        {
          "name": "LA UNION",
          "code": "5400"
        },
        {
          "name": "LIBORINA",
          "code": "5411"
        },
        {
          "name": "MACEO",
          "code": "5425"
        },
        {
          "name": "MARINILLA",
          "code": "5440"
        },
        {
          "name": "MEDELLIN",
          "code": "5001"
        },
        {
          "name": "MONTEBELLO",
          "code": "5467"
        },
        {
          "name": "MURINDO",
          "code": "5475"
        },
        {
          "name": "MUTATA",
          "code": "5480"
        },
        {
          "name": "NARINO",
          "code": "5483"
        },
        {
          "name": "NECHI",
          "code": "5495"
        },
        {
          "name": "NECOCLI",
          "code": "5490"
        },
        {
          "name": "OLAYA",
          "code": "5501"
        },
        {
          "name": "PENOL",
          "code": "5541"
        },
        {
          "name": "PEQUE",
          "code": "5543"
        },
        {
          "name": "PUEBLORRICO",
          "code": "5576"
        },
        {
          "name": "PUERTO BERRiO",
          "code": "5579"
        },
        {
          "name": "PUERTO NARE",
          "code": "5585"
        },
        {
          "name": "PUERTO TRIUNFO",
          "code": "5591"
        },
        {
          "name": "REMEDIOS",
          "code": "5604"
        },
        {
          "name": "RETIRO",
          "code": "5607"
        },
        {
          "name": "RIONEGRO",
          "code": "5615"
        },
        {
          "name": "SABANALARGA",
          "code": "5628"
        },
        {
          "name": "SABANETA",
          "code": "5631"
        },
        {
          "name": "SALGAR",
          "code": "5642"
        },
        {
          "name": "SAN ANDRES",
          "code": "5647"
        },
        {
          "name": "SAN CARLOS",
          "code": "5649"
        },
        {
          "name": "SAN FRANCISCO",
          "code": "5652"
        },
        {
          "name": "SAN JERONIMO",
          "code": "5656"
        },
        {
          "name": "SAN JOSE DE LA MONTANA",
          "code": "5658"
        },
        {
          "name": "SAN JUAN DE URABA",
          "code": "5659"
        },
        {
          "name": "SAN LUIS",
          "code": "5660"
        },
        {
          "name": "SAN PEDRO",
          "code": "5664"
        },
        {
          "name": "SAN PEDRO DE URABA",
          "code": "5665"
        },
        {
          "name": "SAN RAFAEL",
          "code": "5667"
        },
        {
          "name": "SAN ROQUE",
          "code": "5670"
        },
        {
          "name": "SAN VICENTE",
          "code": "5674"
        },
        {
          "name": "SANTA BaRBARA",
          "code": "5679"
        },
        {
          "name": "SANTA ROSA de osos",
          "code": "5686"
        },
        {
          "name": "SANTAFE DE ANTIOQUIA",
          "code": "5042"
        },
        {
          "name": "SANTO DOMINGO",
          "code": "5690"
        },
        {
          "name": "SANTUARIO",
          "code": "5697"
        },
        {
          "name": "SEGOVIA",
          "code": "5736"
        },
        {
          "name": "SONSON",
          "code": "5756"
        },
        {
          "name": "SOPETRaN",
          "code": "5761"
        },
        {
          "name": "TAMESIS",
          "code": "5789"
        },
        {
          "name": "TARAZA",
          "code": "5790"
        },
        {
          "name": "TARSO",
          "code": "5792"
        },
        {
          "name": "TITIRIBI",
          "code": "5809"
        },
        {
          "name": "TOLEDO",
          "code": "5819"
        },
        {
          "name": "TURBO",
          "code": "5837"
        },
        {
          "name": "URAMITA",
          "code": "5842"
        },
        {
          "name": "URRAO",
          "code": "5847"
        },
        {
          "name": "VALDIVIA",
          "code": "5854"
        },
        {
          "name": "VALPARAISO",
          "code": "5856"
        },
        {
          "name": "VEGACHI",
          "code": "5858"
        },
        {
          "name": "VENECIA",
          "code": "5861"
        },
        {
          "name": "VIGIA DEL FUERTE",
          "code": "5873"
        },
        {
          "name": "YALI",
          "code": "5885"
        },
        {
          "name": "YARUMAL",
          "code": "5887"
        },
        {
          "name": "YOLOMBO",
          "code": "5890"
        },
        {
          "name": "YONDO",
          "code": "5893"
        },
        {
          "name": "ZARAGOZA",
          "code": "5895"
        }
      ]
    },
    {
      "name": "ARAUCA",
      "cities": [
        {
          "name": "ARAUCA",
          "code": "81001"
        },
        {
          "name": "ARAUQUITA",
          "code": "81065"
        },
        {
          "name": "CRAVO NORTE",
          "code": "81220"
        },
        {
          "name": "FORTUL",
          "code": "81300"
        },
        {
          "name": "PUERTO RONDON",
          "code": "81591"
        },
        {
          "name": "SARAVENA",
          "code": "81736"
        },
        {
          "name": "TAME",
          "code": "81794"
        }
      ]
    },
    {
      "name": "ARCHIPIELAGO DE SAN ANDRES",
      "cities": [
        {
          "name": "PROVIDENCIA Y SANTA CATALINA",
          "code": "88564"
        },
        {
          "name": "SAN ANDReS",
          "code": "88001"
        }
      ]
    },
    {
      "name": "ATLANTICO",
      "cities": [
        {
          "name": "BARANOA",
          "code": "8078"
        },
        {
          "name": "BARRANQUILLA",
          "code": "8001"
        },
        {
          "name": "CAMPO DE LA CRUZ",
          "code": "8137"
        },
        {
          "name": "CANDELARIA",
          "code": "8141"
        },
        {
          "name": "GALAPA",
          "code": "8296"
        },
        {
          "name": "JUAN DE ACOSTA",
          "code": "8372"
        },
        {
          "name": "LURUACO",
          "code": "8421"
        },
        {
          "name": "MALAMBO",
          "code": "8433"
        },
        {
          "name": "MANATi",
          "code": "8436"
        },
        {
          "name": "PALMAR DE VARELA",
          "code": "8520"
        },
        {
          "name": "PIOJO",
          "code": "8549"
        },
        {
          "name": "POLONUEVO",
          "code": "8558"
        },
        {
          "name": "PONEDERA",
          "code": "8560"
        },
        {
          "name": "PUERTO COLOMBIA",
          "code": "8573"
        },
        {
          "name": "REPELON",
          "code": "8606"
        },
        {
          "name": "Sabanagrande",
          "code": "8634"
        },
        {
          "name": "SABANALARGA",
          "code": "8638"
        },
        {
          "name": "SANTA LUCiA",
          "code": "8675"
        },
        {
          "name": "Santo Tomas",
          "code": "8685"
        },
        {
          "name": "SOLEDAD",
          "code": "8758"
        },
        {
          "name": "SUAN",
          "code": "8770"
        },
        {
          "name": "TUBARA",
          "code": "8832"
        },
        {
          "name": "USIACURi",
          "code": "8849"
        }
      ]
    },
    {
      "name": "BOGOTA D.C.",
      "cities": [
        {
          "name": "BOGOTA D.C.",
          "code": "11001"
        }
      ]
    },
    {
      "name": "BOLIVAR",
      "cities": [
        {
          "name": "ACHI",
          "code": "13006"
        },
        {
          "name": "ALTOS DEL ROSARIO",
          "code": "13030"
        },
        {
          "name": "ARENAL",
          "code": "13042"
        },
        {
          "name": "ARJONA",
          "code": "13052"
        },
        {
          "name": "ARROYOHONDO",
          "code": "13062"
        },
        {
          "name": "BARRANCO DE LOBA",
          "code": "13074"
        },
        {
          "name": "CALAMAR",
          "code": "13140"
        },
        {
          "name": "CANTAGALLO",
          "code": "13160"
        },
        {
          "name": "CARMEN DE BOLIVAR",
          "code": "13244"
        },
        {
          "name": "CARTAGENA",
          "code": "13001"
        },
        {
          "name": "CICUCO",
          "code": "13188"
        },
        {
          "name": "CLEMENCIA",
          "code": "13222"
        },
        {
          "name": "CORDOBA",
          "code": "13212"
        },
        {
          "name": "EL GUAMO",
          "code": "13248"
        },
        {
          "name": "EL PENON",
          "code": "13268"
        },
        {
          "name": "HATILLO DE LOBA",
          "code": "13300"
        },
        {
          "name": "MAGANGUE",
          "code": "13430"
        },
        {
          "name": "MAHATES",
          "code": "13433"
        },
        {
          "name": "MARGARITA",
          "code": "13440"
        },
        {
          "name": "MARIA LA BAJA",
          "code": "13442"
        },
        {
          "name": "MOMPOS",
          "code": "13468"
        },
        {
          "name": "MONTECRISTO",
          "code": "13458"
        },
        {
          "name": "MORALES",
          "code": "13473"
        },
        {
          "name": "PINILLOS",
          "code": "13549"
        },
        {
          "name": "REGIDOR",
          "code": "13580"
        },
        {
          "name": "RIO VIEJO",
          "code": "13600"
        },
        {
          "name": "SAN CRISTOBAL",
          "code": "13620"
        },
        {
          "name": "SAN ESTANISLAO",
          "code": "13647"
        },
        {
          "name": "SAN FERNANDO",
          "code": "13650"
        },
        {
          "name": "SAN JACINTO",
          "code": "13654"
        },
        {
          "name": "SAN JACINTO DEL CAUCA",
          "code": "13655"
        },
        {
          "name": "SAN JUAN NEPOMUCENO",
          "code": "13657"
        },
        {
          "name": "SAN MARTIN DE LOBA",
          "code": "13667"
        },
        {
          "name": "SAN PABLO",
          "code": "13670"
        },
        {
          "name": "SANTA CATALINA",
          "code": "13673"
        },
        {
          "name": "SANTA ROSA DE LIMA",
          "code": "13683"
        },
        {
          "name": "SANTA ROSA DEL SUR",
          "code": "13688"
        },
        {
          "name": "SIMITI",
          "code": "13744"
        },
        {
          "name": "SOPLAVIENTO",
          "code": "13760"
        },
        {
          "name": "TALAIGUA NUEVO",
          "code": "13780"
        },
        {
          "name": "TIQUISIO",
          "code": "13810"
        },
        {
          "name": "TURBACO",
          "code": "13836"
        },
        {
          "name": "TURBANA",
          "code": "13838"
        },
        {
          "name": "VILLANUEVA",
          "code": "13873"
        },
        {
          "name": "ZAMBRANO",
          "code": "13894"
        }
      ]
    },
    {
      "name": "BOYACA",
      "cities": [
        {
          "name": "ALMEIDA",
          "code": "15022"
        },
        {
          "name": "AQUITANIA",
          "code": "15047"
        },
        {
          "name": "ARCABUCO",
          "code": "15051"
        },
        {
          "name": "BELEN",
          "code": "15087"
        },
        {
          "name": "BERBEO",
          "code": "15090"
        },
        {
          "name": "BETEITIVA",
          "code": "15092"
        },
        {
          "name": "BOAVITA",
          "code": "15097"
        },
        {
          "name": "BOYACA",
          "code": "15104"
        },
        {
          "name": "BRICENO",
          "code": "15106"
        },
        {
          "name": "BUENAVISTA",
          "code": "15109"
        },
        {
          "name": "BUSBANZA",
          "code": "15114"
        },
        {
          "name": "CALDAS",
          "code": "15131"
        },
        {
          "name": "CAMPOHERMOSO",
          "code": "15135"
        },
        {
          "name": "CERINZA",
          "code": "15162"
        },
        {
          "name": "CHINAVITA",
          "code": "15172"
        },
        {
          "name": "CHIQUINQUIRA",
          "code": "15176"
        },
        {
          "name": "CHIQUIZA",
          "code": "15232"
        },
        {
          "name": "CHISCAS",
          "code": "15180"
        },
        {
          "name": "CHITA",
          "code": "15183"
        },
        {
          "name": "CHITARAQUE",
          "code": "15185"
        },
        {
          "name": "CHIVATA",
          "code": "15187"
        },
        {
          "name": "CHIVOR",
          "code": "15236"
        },
        {
          "name": "CIENEGA",
          "code": "15189"
        },
        {
          "name": "COMBITA",
          "code": "15204"
        },
        {
          "name": "COPER",
          "code": "15212"
        },
        {
          "name": "CORRALES",
          "code": "15215"
        },
        {
          "name": "COVARACHIA",
          "code": "15218"
        },
        {
          "name": "CUBARA",
          "code": "15223"
        },
        {
          "name": "CUCAITA",
          "code": "15224"
        },
        {
          "name": "CUITIVA",
          "code": "15226"
        },
        {
          "name": "DUITAMA",
          "code": "15238"
        },
        {
          "name": "EL COCUY",
          "code": "15244"
        },
        {
          "name": "EL ESPINO",
          "code": "15248"
        },
        {
          "name": "FIRAVITOBA",
          "code": "15272"
        },
        {
          "name": "FLORESTA",
          "code": "15276"
        },
        {
          "name": "GACHANTIVA",
          "code": "15293"
        },
        {
          "name": "GAMEZA",
          "code": "15296"
        },
        {
          "name": "GARAGOA",
          "code": "15299"
        },
        {
          "name": "GUACAMAYAS",
          "code": "15317"
        },
        {
          "name": "GUATEQUE",
          "code": "15322"
        },
        {
          "name": "GUAYATA",
          "code": "15325"
        },
        {
          "name": "GÜICAN",
          "code": "15332"
        },
        {
          "name": "IZA",
          "code": "15362"
        },
        {
          "name": "JENESANO",
          "code": "15367"
        },
        {
          "name": "JERICO",
          "code": "15368"
        },
        {
          "name": "LA CAPILLA",
          "code": "15380"
        },
        {
          "name": "LA UVITA",
          "code": "15403"
        },
        {
          "name": "LA VICTORIA",
          "code": "15401"
        },
        {
          "name": "LABRANZAGRANDE",
          "code": "15377"
        },
        {
          "name": "MACANAL",
          "code": "15425"
        },
        {
          "name": "MARIPI",
          "code": "15442"
        },
        {
          "name": "MIRAFLORES",
          "code": "15455"
        },
        {
          "name": "MONGUA",
          "code": "15464"
        },
        {
          "name": "MONGUI",
          "code": "15466"
        },
        {
          "name": "MONIQUIRA",
          "code": "15469"
        },
        {
          "name": "MOTAVITA",
          "code": "15476"
        },
        {
          "name": "MUZO",
          "code": "15480"
        },
        {
          "name": "NOBSA",
          "code": "15491"
        },
        {
          "name": "NUEVO COLON",
          "code": "15494"
        },
        {
          "name": "OICATA",
          "code": "15500"
        },
        {
          "name": "OTANCHE",
          "code": "15507"
        },
        {
          "name": "PACHAVITA",
          "code": "15511"
        },
        {
          "name": "PAEZ",
          "code": "15514"
        },
        {
          "name": "PAIPA",
          "code": "15516"
        },
        {
          "name": "PAJARITO",
          "code": "15518"
        },
        {
          "name": "PANQUEBA",
          "code": "15522"
        },
        {
          "name": "PAUNA",
          "code": "15531"
        },
        {
          "name": "PAYA",
          "code": "15533"
        },
        {
          "name": "PAZ DE RIO",
          "code": "15537"
        },
        {
          "name": "PESCA",
          "code": "15542"
        },
        {
          "name": "PISBA",
          "code": "15550"
        },
        {
          "name": "PUERTO BOYACa",
          "code": "15572"
        },
        {
          "name": "QUIPAMA",
          "code": "15580"
        },
        {
          "name": "RAMIRIQUI",
          "code": "15599"
        },
        {
          "name": "RAQUIRA",
          "code": "15600"
        },
        {
          "name": "RONDON",
          "code": "15621"
        },
        {
          "name": "SABOYA",
          "code": "15632"
        },
        {
          "name": "SACHICA",
          "code": "15638"
        },
        {
          "name": "SAMACA",
          "code": "15646"
        },
        {
          "name": "SAN EDUARDO",
          "code": "15660"
        },
        {
          "name": "SAN JOSE DE PARE",
          "code": "15664"
        },
        {
          "name": "SAN LUIS DE GACENO",
          "code": "15667"
        },
        {
          "name": "SAN MATEO",
          "code": "15673"
        },
        {
          "name": "SAN MIGUEL DE SEMA",
          "code": "15676"
        },
        {
          "name": "SAN PABLO BORBUR",
          "code": "15681"
        },
        {
          "name": "SAN ROSA VITERBO",
          "code": "15693"
        },
        {
          "name": "SANTA MARIA",
          "code": "15690"
        },
        {
          "name": "SANTA SOFIA",
          "code": "15696"
        },
        {
          "name": "SANTANA",
          "code": "15686"
        },
        {
          "name": "SATIVANORTE",
          "code": "15720"
        },
        {
          "name": "SATIVASUR",
          "code": "15723"
        },
        {
          "name": "SIACHOQUE",
          "code": "15740"
        },
        {
          "name": "SOATA",
          "code": "15753"
        },
        {
          "name": "SOCHA",
          "code": "15757"
        },
        {
          "name": "SOCOTA",
          "code": "15755"
        },
        {
          "name": "SOGAMOSO",
          "code": "15759"
        },
        {
          "name": "SOMONDOCO",
          "code": "15761"
        },
        {
          "name": "SORA",
          "code": "15762"
        },
        {
          "name": "SORACA",
          "code": "15764"
        },
        {
          "name": "SOTAQUIRA",
          "code": "15763"
        },
        {
          "name": "SUSACON",
          "code": "15774"
        },
        {
          "name": "SUTAMARCHAN",
          "code": "15776"
        },
        {
          "name": "SUTATENZA",
          "code": "15778"
        },
        {
          "name": "TASCO",
          "code": "15790"
        },
        {
          "name": "TENZA",
          "code": "15798"
        },
        {
          "name": "TIBANA",
          "code": "15804"
        },
        {
          "name": "TIBASOSA",
          "code": "15806"
        },
        {
          "name": "TINJACA",
          "code": "15808"
        },
        {
          "name": "TIPACOQUE",
          "code": "15810"
        },
        {
          "name": "TOCA",
          "code": "15814"
        },
        {
          "name": "TOGÜI",
          "code": "15816"
        },
        {
          "name": "TOPAGA",
          "code": "15820"
        },
        {
          "name": "TOTA",
          "code": "15822"
        },
        {
          "name": "TUNJA",
          "code": "15001"
        },
        {
          "name": "TUNUNGUA",
          "code": "15832"
        },
        {
          "name": "TURMEQUE",
          "code": "15835"
        },
        {
          "name": "TUTA",
          "code": "15837"
        },
        {
          "name": "TUTAZA",
          "code": "15839"
        },
        {
          "name": "UMBITA",
          "code": "15842"
        },
        {
          "name": "VENTAQUEMADA",
          "code": "15861"
        },
        {
          "name": "VILLA DE LEYVA",
          "code": "15407"
        },
        {
          "name": "VIRACACHA",
          "code": "15879"
        },
        {
          "name": "ZETAQUIRA",
          "code": "15897"
        }
      ]
    },
    {
      "name": "CALDAS",
      "cities": [
        {
          "name": "AGUADAS",
          "code": "17013"
        },
        {
          "name": "ANSERMA",
          "code": "17042"
        },
        {
          "name": "ARANZAZU",
          "code": "17050"
        },
        {
          "name": "BELALCAZAR",
          "code": "17088"
        },
        {
          "name": "CHINCHINa",
          "code": "17174"
        },
        {
          "name": "FILADELFIA",
          "code": "17272"
        },
        {
          "name": "LA DORADA",
          "code": "17380"
        },
        {
          "name": "LA MERCED",
          "code": "17388"
        },
        {
          "name": "MANIZALES",
          "code": "17001"
        },
        {
          "name": "MANZANARES",
          "code": "17433"
        },
        {
          "name": "MARMATO",
          "code": "17442"
        },
        {
          "name": "MARQUETALIA",
          "code": "17444"
        },
        {
          "name": "MARULANDA",
          "code": "17446"
        },
        {
          "name": "NEIRA",
          "code": "17486"
        },
        {
          "name": "NORCASIA",
          "code": "17495"
        },
        {
          "name": "PACORA",
          "code": "17513"
        },
        {
          "name": "PALESTINA",
          "code": "17524"
        },
        {
          "name": "PENSILVANIA",
          "code": "17541"
        },
        {
          "name": "RIOSUCIO",
          "code": "17614"
        },
        {
          "name": "RISARALDA",
          "code": "17616"
        },
        {
          "name": "SALAMINA",
          "code": "17653"
        },
        {
          "name": "SAMANA",
          "code": "17662"
        },
        {
          "name": "SAN JOSE",
          "code": "17665"
        },
        {
          "name": "SUPIA",
          "code": "17777"
        },
        {
          "name": "VICTORIA",
          "code": "17867"
        },
        {
          "name": "VILLAMARiA",
          "code": "17873"
        },
        {
          "name": "VITERBO",
          "code": "17877"
        }
      ]
    },
    {
      "name": "CAQUETA",
      "cities": [
        {
          "name": "ALBANIA",
          "code": "18029"
        },
        {
          "name": "BELEN DE LOS ANDAQUIES",
          "code": "18094"
        },
        {
          "name": "CARTAGENA DEL CHAIRA",
          "code": "18150"
        },
        {
          "name": "CURRILLO",
          "code": "18205"
        },
        {
          "name": "EL DONCELLO",
          "code": "18247"
        },
        {
          "name": "EL PAUJIL",
          "code": "18256"
        },
        {
          "name": "FLORENCIA",
          "code": "18001"
        },
        {
          "name": "LA MONTANITA",
          "code": "18410"
        },
        {
          "name": "MILaN",
          "code": "18460"
        },
        {
          "name": "MORELIA",
          "code": "18479"
        },
        {
          "name": "PUERTO RICO",
          "code": "18592"
        },
        {
          "name": "SAN JOSE DEL FRAGUA",
          "code": "18610"
        },
        {
          "name": "SAN VICENTE DEL CAGUAN",
          "code": "18753"
        },
        {
          "name": "SOLANO",
          "code": "18756"
        },
        {
          "name": "SOLITA",
          "code": "18785"
        },
        {
          "name": "VALPARAISO",
          "code": "18860"
        }
      ]
    },
    {
      "name": "CASANARE",
      "cities": [
        {
          "name": "AGUAZUL",
          "code": "85010"
        },
        {
          "name": "CHAMEZA",
          "code": "85015"
        },
        {
          "name": "HATO COROZAL",
          "code": "85125"
        },
        {
          "name": "LA SALINA",
          "code": "85136"
        },
        {
          "name": "MANI",
          "code": "85139"
        },
        {
          "name": "MONTERREY",
          "code": "85162"
        },
        {
          "name": "NUNCHIA",
          "code": "85225"
        },
        {
          "name": "OROCUE",
          "code": "85230"
        },
        {
          "name": "PAZ DE ARIPORO",
          "code": "85250"
        },
        {
          "name": "PORE",
          "code": "85263"
        },
        {
          "name": "RECETOR",
          "code": "85279"
        },
        {
          "name": "SABANALARGA",
          "code": "85300"
        },
        {
          "name": "SACAMA",
          "code": "85315"
        },
        {
          "name": "SAN LUIS DE PALENQUE",
          "code": "85325"
        },
        {
          "name": "TAMARA",
          "code": "85400"
        },
        {
          "name": "TAURAMENA",
          "code": "85410"
        },
        {
          "name": "TRINIDAD",
          "code": "85430"
        },
        {
          "name": "VILLANUEVA",
          "code": "85440"
        },
        {
          "name": "YOPAL",
          "code": "85001"
        }
      ]
    },
    {
      "name": "CAUCA",
      "cities": [
        {
          "name": "ALMAGUER",
          "code": "19022"
        },
        {
          "name": "ARGELIA",
          "code": "19050"
        },
        {
          "name": "BALBOA",
          "code": "19075"
        },
        {
          "name": "BOLIVAR",
          "code": "19100"
        },
        {
          "name": "BUENOS AIRES",
          "code": "19110"
        },
        {
          "name": "CAJIBIO",
          "code": "19130"
        },
        {
          "name": "CALDONO",
          "code": "19137"
        },
        {
          "name": "CALOTO",
          "code": "19142"
        },
        {
          "name": "CORINTO",
          "code": "19212"
        },
        {
          "name": "EL TAMBO",
          "code": "19256"
        },
        {
          "name": "FLORENCIA",
          "code": "19290"
        },
        {
          "name": "GUAPI",
          "code": "19318"
        },
        {
          "name": "INZA",
          "code": "19355"
        },
        {
          "name": "JAMBALO",
          "code": "19364"
        },
        {
          "name": "LA SIERRA",
          "code": "19392"
        },
        {
          "name": "LA VEGA",
          "code": "19397"
        },
        {
          "name": "LOPEZ",
          "code": "19418"
        },
        {
          "name": "MERCADERES",
          "code": "19450"
        },
        {
          "name": "MIRANDA",
          "code": "19455"
        },
        {
          "name": "MORALES",
          "code": "19473"
        },
        {
          "name": "PADILLA",
          "code": "19513"
        },
        {
          "name": "PAEZ",
          "code": "19517"
        },
        {
          "name": "PATIA",
          "code": "19532"
        },
        {
          "name": "PIAMONTE",
          "code": "19533"
        },
        {
          "name": "PIENDAMO",
          "code": "19548"
        },
        {
          "name": "POPAYAN",
          "code": "19001"
        },
        {
          "name": "PUERTO TEJADA",
          "code": "19573"
        },
        {
          "name": "PURACE",
          "code": "19585"
        },
        {
          "name": "ROSAS",
          "code": "19622"
        },
        {
          "name": "SAN SEBASTIAN",
          "code": "19693"
        },
        {
          "name": "SANTA ROSA",
          "code": "19701"
        },
        {
          "name": "SANTANDER DE QUILICHAO",
          "code": "19698"
        },
        {
          "name": "Silvia",
          "code": "19743"
        },
        {
          "name": "SOTARA",
          "code": "19760"
        },
        {
          "name": "SUAREZ",
          "code": "19780"
        },
        {
          "name": "SUCRE",
          "code": "19785"
        },
        {
          "name": "TIMBIO",
          "code": "19807"
        },
        {
          "name": "TIMBIQUI",
          "code": "19809"
        },
        {
          "name": "TORIBIO",
          "code": "19821"
        },
        {
          "name": "TOTORO",
          "code": "19824"
        },
        {
          "name": "VILLA RICA",
          "code": "19845"
        }
      ]
    },
    {
      "name": "CESAR",
      "cities": [
        {
          "name": "AGUACHICA",
          "code": "20011"
        },
        {
          "name": "AGUSTIN CODAZZI",
          "code": "20013"
        },
        {
          "name": "ASTREA",
          "code": "20032"
        },
        {
          "name": "BECERRIL",
          "code": "20045"
        },
        {
          "name": "BOSCONIA",
          "code": "20060"
        },
        {
          "name": "CHIMICHAGUA",
          "code": "20175"
        },
        {
          "name": "CHIRIGUANA",
          "code": "20178"
        },
        {
          "name": "CURUMANI",
          "code": "20228"
        },
        {
          "name": "EL COPEY",
          "code": "20238"
        },
        {
          "name": "EL PASO",
          "code": "20250"
        },
        {
          "name": "GAMARRA",
          "code": "20295"
        },
        {
          "name": "GONZALEZ",
          "code": "20310"
        },
        {
          "name": "LA GLORIA",
          "code": "20383"
        },
        {
          "name": "LA JAGUA DE IBIRICO",
          "code": "20400"
        },
        {
          "name": "LA PAZ",
          "code": "20621"
        },
        {
          "name": "MANAURE",
          "code": "20443"
        },
        {
          "name": "PAILITAS",
          "code": "20517"
        },
        {
          "name": "PELAYA",
          "code": "20550"
        },
        {
          "name": "PUEBLO BELLO",
          "code": "20570"
        },
        {
          "name": "RIO DE ORO",
          "code": "20614"
        },
        {
          "name": "SAN ALBERTO",
          "code": "20710"
        },
        {
          "name": "SAN DIEGO",
          "code": "20750"
        },
        {
          "name": "SAN MARTIN",
          "code": "20770"
        },
        {
          "name": "TAMALAMEQUE",
          "code": "20787"
        },
        {
          "name": "VALLEDUPAR",
          "code": "20001"
        }
      ]
    },
    {
      "name": "CHOCO",
      "cities": [
        {
          "name": "ACANDI",
          "code": "27006"
        },
        {
          "name": "ALTO BAUDO",
          "code": "27025"
        },
        {
          "name": "ATRATO",
          "code": "27050"
        },
        {
          "name": "BAGADO",
          "code": "27073"
        },
        {
          "name": "BAHIA SOLANO",
          "code": "27075"
        },
        {
          "name": "BAJO BAUDO",
          "code": "27077"
        },
        {
          "name": "BELEN DE BAJIRA",
          "code": "27086"
        },
        {
          "name": "BOJAYA",
          "code": "27099"
        },
        {
          "name": "CANTON DE SAN PABLO",
          "code": "27135"
        },
        {
          "name": "CARMEN DEL DARIEN",
          "code": "27150"
        },
        {
          "name": "CERTEGUI",
          "code": "27160"
        },
        {
          "name": "CONDOTO",
          "code": "27205"
        },
        {
          "name": "EL CARMEN DE ATRATO",
          "code": "27245"
        },
        {
          "name": "El Litoral del San Juan",
          "code": "27250"
        },
        {
          "name": "ITSMINA",
          "code": "27361"
        },
        {
          "name": "JURADO",
          "code": "27372"
        },
        {
          "name": "LLORO",
          "code": "27413"
        },
        {
          "name": "MEDIO ATRATO",
          "code": "27425"
        },
        {
          "name": "MEDIO BAUDO",
          "code": "27430"
        },
        {
          "name": "MEDIO SAN JUAN",
          "code": "27450"
        },
        {
          "name": "NOVITA",
          "code": "27491"
        },
        {
          "name": "NUQUI",
          "code": "27495"
        },
        {
          "name": "QUIBDO",
          "code": "27001"
        },
        {
          "name": "RIO FRIO",
          "code": "27580"
        },
        {
          "name": "RIO QUITO",
          "code": "27600"
        },
        {
          "name": "RIOSUCIO",
          "code": "27615"
        },
        {
          "name": "SAN JOSE DEL PALMAR",
          "code": "27660"
        },
        {
          "name": "SIPI",
          "code": "27745"
        },
        {
          "name": "TADO",
          "code": "27787"
        },
        {
          "name": "UNGUIA",
          "code": "27800"
        },
        {
          "name": "UNION PANAMERICANA",
          "code": "27810"
        }
      ]
    },
    {
      "name": "CORDOBA",
      "cities": [
        {
          "name": "AYAPEL",
          "code": "23068"
        },
        {
          "name": "BUENAVISTA",
          "code": "23079"
        },
        {
          "name": "CANALETE",
          "code": "23090"
        },
        {
          "name": "CERETE",
          "code": "23162"
        },
        {
          "name": "CHIMA",
          "code": "23168"
        },
        {
          "name": "CHINU",
          "code": "23182"
        },
        {
          "name": "CIENAGA DE ORO",
          "code": "23189"
        },
        {
          "name": "COTORRA",
          "code": "23300"
        },
        {
          "name": "LA APARTADA",
          "code": "23350"
        },
        {
          "name": "LORICA",
          "code": "23417"
        },
        {
          "name": "LOS CORDOBAS",
          "code": "23419"
        },
        {
          "name": "MOMIL",
          "code": "23464"
        },
        {
          "name": "MONITOS",
          "code": "23500"
        },
        {
          "name": "MONTELIBANO",
          "code": "23466"
        },
        {
          "name": "MONTERIA",
          "code": "23001"
        },
        {
          "name": "PLANETA RICA",
          "code": "23555"
        },
        {
          "name": "PUEBLO NUEVO",
          "code": "23570"
        },
        {
          "name": "PUERTO ESCONDIDO",
          "code": "23574"
        },
        {
          "name": "PUERTO LIBERTADOR",
          "code": "23580"
        },
        {
          "name": "PURISIMA",
          "code": "23586"
        },
        {
          "name": "SAHAGUN",
          "code": "23660"
        },
        {
          "name": "SAN ANDRES SOTAVENTO",
          "code": "23670"
        },
        {
          "name": "SAN ANTERO",
          "code": "23672"
        },
        {
          "name": "SAN BERNARDO DEL VIENTO",
          "code": "23675"
        },
        {
          "name": "SAN CARLOS",
          "code": "23678"
        },
        {
          "name": "SAN PELAYO",
          "code": "23686"
        },
        {
          "name": "TIERRALTA",
          "code": "23807"
        },
        {
          "name": "VALENCIA",
          "code": "23855"
        }
      ]
    },
    {
      "name": "CUNDINAMARCA",
      "cities": [
        {
          "name": "AGUA DE DIOS",
          "code": "25001"
        },
        {
          "name": "ALBAN",
          "code": "25019"
        },
        {
          "name": "ANAPOIMA",
          "code": "25035"
        },
        {
          "name": "ANOLAIMA",
          "code": "25040"
        },
        {
          "name": "APULO",
          "code": "25599"
        },
        {
          "name": "ARBELAEZ",
          "code": "25053"
        },
        {
          "name": "BELTRAN",
          "code": "25086"
        },
        {
          "name": "BITUIMA",
          "code": "25095"
        },
        {
          "name": "BOJACA",
          "code": "25099"
        },
        {
          "name": "CABRERA",
          "code": "25120"
        },
        {
          "name": "CACHIPAY",
          "code": "25123"
        },
        {
          "name": "CAJICA",
          "code": "25126"
        },
        {
          "name": "CAPARRAPI",
          "code": "25148"
        },
        {
          "name": "CAQUEZA",
          "code": "25151"
        },
        {
          "name": "CARMEN DE CARUPA",
          "code": "25154"
        },
        {
          "name": "CHAGUANI",
          "code": "25168"
        },
        {
          "name": "CHIA",
          "code": "25175"
        },
        {
          "name": "CHIPAQUE",
          "code": "25178"
        },
        {
          "name": "CHOACHI",
          "code": "25181"
        },
        {
          "name": "CHOCONTA",
          "code": "25183"
        },
        {
          "name": "COGUA",
          "code": "25200"
        },
        {
          "name": "COTA",
          "code": "25214"
        },
        {
          "name": "CUCUNUBA",
          "code": "25224"
        },
        {
          "name": "EL COLEGIO",
          "code": "25245"
        },
        {
          "name": "EL PENON",
          "code": "25258"
        },
        {
          "name": "EL ROSAL",
          "code": "25260"
        },
        {
          "name": "FACATATIVA",
          "code": "25269"
        },
        {
          "name": "FOMEQUE",
          "code": "25279"
        },
        {
          "name": "FOSCA",
          "code": "25281"
        },
        {
          "name": "FUNZA",
          "code": "25286"
        },
        {
          "name": "FUQUENE",
          "code": "25288"
        },
        {
          "name": "FUSAGASUGA",
          "code": "25290"
        },
        {
          "name": "GACHALA",
          "code": "25293"
        },
        {
          "name": "GACHANCIPA",
          "code": "25295"
        },
        {
          "name": "GACHETA",
          "code": "25297"
        },
        {
          "name": "GAMA",
          "code": "25299"
        },
        {
          "name": "GIRARDOT",
          "code": "25307"
        },
        {
          "name": "GRANADA",
          "code": "25312"
        },
        {
          "name": "GUACHETA",
          "code": "25317"
        },
        {
          "name": "GUADUAS",
          "code": "25320"
        },
        {
          "name": "GUASCA",
          "code": "25322"
        },
        {
          "name": "GUATAQUI",
          "code": "25324"
        },
        {
          "name": "GUATAVITA",
          "code": "25326"
        },
        {
          "name": "GUAYABAL DE SIQUIMA",
          "code": "25328"
        },
        {
          "name": "GUAYABETAL",
          "code": "25335"
        },
        {
          "name": "GUTIERREZ",
          "code": "25339"
        },
        {
          "name": "JERUSALEN",
          "code": "25368"
        },
        {
          "name": "JUNIN",
          "code": "25372"
        },
        {
          "name": "LA CALERA",
          "code": "25377"
        },
        {
          "name": "LA MESA",
          "code": "25386"
        },
        {
          "name": "LA PALMA",
          "code": "25394"
        },
        {
          "name": "LA PENA",
          "code": "25398"
        },
        {
          "name": "LA VEGA",
          "code": "25402"
        },
        {
          "name": "LENGUAZAQUE",
          "code": "25407"
        },
        {
          "name": "MACHETA",
          "code": "25426"
        },
        {
          "name": "MADRID",
          "code": "25430"
        },
        {
          "name": "MANTA",
          "code": "25436"
        },
        {
          "name": "MEDINA",
          "code": "25438"
        },
        {
          "name": "MOSQUERA",
          "code": "25473"
        },
        {
          "name": "NARINO",
          "code": "25483"
        },
        {
          "name": "NEMOCoN",
          "code": "25486"
        },
        {
          "name": "NILO",
          "code": "25488"
        },
        {
          "name": "NIMAIMA",
          "code": "25489"
        },
        {
          "name": "NOCAIMA",
          "code": "25491"
        },
        {
          "name": "PACHO",
          "code": "25513"
        },
        {
          "name": "PAIME",
          "code": "25518"
        },
        {
          "name": "PANDI",
          "code": "25524"
        },
        {
          "name": "PARATEBUENO",
          "code": "25530"
        },
        {
          "name": "PASCA",
          "code": "25535"
        },
        {
          "name": "PUERTO SALGAR",
          "code": "25572"
        },
        {
          "name": "PULI",
          "code": "25580"
        },
        {
          "name": "QUEBRADANEGRA",
          "code": "25592"
        },
        {
          "name": "QUETAME",
          "code": "25594"
        },
        {
          "name": "QUIPILE",
          "code": "25596"
        },
        {
          "name": "RICAURTE",
          "code": "25612"
        },
        {
          "name": "SAN ANTONIO DE TEQUENDAMA",
          "code": "25645"
        },
        {
          "name": "SAN BERNARDO",
          "code": "25649"
        },
        {
          "name": "SAN CAYETANO",
          "code": "25653"
        },
        {
          "name": "SAN FRANCISCO",
          "code": "25658"
        },
        {
          "name": "SAN JUAN DE RIO SECO",
          "code": "25662"
        },
        {
          "name": "SASAIMA",
          "code": "25718"
        },
        {
          "name": "SESQUILE",
          "code": "25736"
        },
        {
          "name": "SIBATE",
          "code": "25740"
        },
        {
          "name": "SILVANIA",
          "code": "25743"
        },
        {
          "name": "SIMIJACA",
          "code": "25745"
        },
        {
          "name": "SOACHA",
          "code": "25754"
        },
        {
          "name": "SOPO",
          "code": "25758"
        },
        {
          "name": "SUBACHOQUE",
          "code": "25769"
        },
        {
          "name": "SUESCA",
          "code": "25772"
        },
        {
          "name": "SUPATA",
          "code": "25777"
        },
        {
          "name": "SUSA",
          "code": "25779"
        },
        {
          "name": "SUTATAUSA",
          "code": "25781"
        },
        {
          "name": "TABIO",
          "code": "25785"
        },
        {
          "name": "TAUSA",
          "code": "25793"
        },
        {
          "name": "TENA",
          "code": "25797"
        },
        {
          "name": "TENJO",
          "code": "25799"
        },
        {
          "name": "TIBACUY",
          "code": "25805"
        },
        {
          "name": "TIBIRITA",
          "code": "25807"
        },
        {
          "name": "TOCAIMA",
          "code": "25815"
        },
        {
          "name": "TOCANCIPA",
          "code": "25817"
        },
        {
          "name": "TOPAIPI",
          "code": "25823"
        },
        {
          "name": "UBALA",
          "code": "25839"
        },
        {
          "name": "UBAQUE",
          "code": "25841"
        },
        {
          "name": "UBATE",
          "code": "25843"
        },
        {
          "name": "UNE",
          "code": "25845"
        },
        {
          "name": "UTICA",
          "code": "25851"
        },
        {
          "name": "VENECIA",
          "code": "25506"
        },
        {
          "name": "VERGARA",
          "code": "25862"
        },
        {
          "name": "VIANI",
          "code": "25867"
        },
        {
          "name": "VILLAGOMEZ",
          "code": "25871"
        },
        {
          "name": "VILLAPINZON",
          "code": "25873"
        },
        {
          "name": "VILLETA",
          "code": "25875"
        },
        {
          "name": "VIOTA",
          "code": "25878"
        },
        {
          "name": "YACOPI",
          "code": "25885"
        },
        {
          "name": "ZIPACoN",
          "code": "25898"
        },
        {
          "name": "ZIPAQUIRA",
          "code": "25899"
        }
      ]
    },
    {
      "name": "GUAINIA",
      "cities": [
        {
          "name": "BARRANCO MINA",
          "code": "94343"
        },
        {
          "name": "CACAHUAL",
          "code": "94886"
        },
        {
          "name": "INIRIDA",
          "code": "94001"
        },
        {
          "name": "LA GUADALUPE",
          "code": "94885"
        },
        {
          "name": "MAPIRIPaN",
          "code": "94663"
        },
        {
          "name": "MORICHAL",
          "code": "94888"
        },
        {
          "name": "PANA PANA",
          "code": "94887"
        },
        {
          "name": "PUERTO COLOMBIA",
          "code": "94884"
        },
        {
          "name": "SAN FELIPE",
          "code": "94883"
        }
      ]
    },
    {
      "name": "GUAVIARE",
      "cities": [
        {
          "name": "CALAMAR",
          "code": "95015"
        },
        {
          "name": "EL RETORNO",
          "code": "95025"
        },
        {
          "name": "MIRAFLORES",
          "code": "95200"
        },
        {
          "name": "SAN JOSE DEL GUAVIARE",
          "code": "95001"
        }
      ]
    },
    {
      "name": "HUILA",
      "cities": [
        {
          "name": "ACEVEDO",
          "code": "41006"
        },
        {
          "name": "AGRADO",
          "code": "41013"
        },
        {
          "name": "AIPE",
          "code": "41016"
        },
        {
          "name": "ALGECIRAS",
          "code": "41020"
        },
        {
          "name": "ALTAMIRA",
          "code": "41026"
        },
        {
          "name": "BARAYA",
          "code": "41078"
        },
        {
          "name": "CAMPOALEGRE",
          "code": "41132"
        },
        {
          "name": "COLOMBIA",
          "code": "41206"
        },
        {
          "name": "ELIAS",
          "code": "41244"
        },
        {
          "name": "GARZON",
          "code": "41298"
        },
        {
          "name": "GIGANTE",
          "code": "41306"
        },
        {
          "name": "GUADALUPE",
          "code": "41319"
        },
        {
          "name": "HOBO",
          "code": "41349"
        },
        {
          "name": "IQUIRA",
          "code": "41357"
        },
        {
          "name": "ISNOS",
          "code": "41359"
        },
        {
          "name": "LA ARGENTINA",
          "code": "41378"
        },
        {
          "name": "LA PLATA",
          "code": "41396"
        },
        {
          "name": "NATAGA",
          "code": "41483"
        },
        {
          "name": "NEIVA",
          "code": "41001"
        },
        {
          "name": "OPORAPA",
          "code": "41503"
        },
        {
          "name": "PAICOL",
          "code": "41518"
        },
        {
          "name": "PALERMO",
          "code": "41524"
        },
        {
          "name": "PALESTINA",
          "code": "41530"
        },
        {
          "name": "PITAL",
          "code": "41548"
        },
        {
          "name": "PITALITO",
          "code": "41551"
        },
        {
          "name": "RIVERA",
          "code": "41615"
        },
        {
          "name": "SALADOBLANCO",
          "code": "41660"
        },
        {
          "name": "SAN AGUSTIN",
          "code": "41668"
        },
        {
          "name": "SANTA MARIA",
          "code": "41676"
        },
        {
          "name": "SUAZA",
          "code": "41770"
        },
        {
          "name": "TARQUI",
          "code": "41791"
        },
        {
          "name": "TELLO",
          "code": "41799"
        },
        {
          "name": "TERUEL",
          "code": "41801"
        },
        {
          "name": "TESALIA",
          "code": "41797"
        },
        {
          "name": "TIMANA",
          "code": "41807"
        },
        {
          "name": "VILLAVIEJA",
          "code": "41872"
        },
        {
          "name": "YAGUARA",
          "code": "41885"
        }
      ]
    },
    {
      "name": "LA GUAJIRA",
      "cities": [
        {
          "name": "ALBANIA",
          "code": "44035"
        },
        {
          "name": "BARRANCAS",
          "code": "44078"
        },
        {
          "name": "DIBULLA",
          "code": "44090"
        },
        {
          "name": "DISTRACCION",
          "code": "44098"
        },
        {
          "name": "EL MOLINO",
          "code": "44110"
        },
        {
          "name": "FONSECA",
          "code": "44279"
        },
        {
          "name": "HATONUEVO",
          "code": "44378"
        },
        {
          "name": "LA JAGUA DEL PILAR",
          "code": "44420"
        },
        {
          "name": "MAICAO",
          "code": "44430"
        },
        {
          "name": "MANAURE",
          "code": "44560"
        },
        {
          "name": "RIOHACHA",
          "code": "44001"
        },
        {
          "name": "SAN JUAN DEL CESAR",
          "code": "44650"
        },
        {
          "name": "URIBIA",
          "code": "44847"
        },
        {
          "name": "URUMITA",
          "code": "44855"
        },
        {
          "name": "VILLANUEVA",
          "code": "44874"
        }
      ]
    },
    {
      "name": "MAGDALENA",
      "cities": [
        {
          "name": "ALGARROBO",
          "code": "47030"
        },
        {
          "name": "ARACATACA",
          "code": "47053"
        },
        {
          "name": "ARIGUANI",
          "code": "47058"
        },
        {
          "name": "CERRO SAN ANTONIO",
          "code": "47161"
        },
        {
          "name": "CHIBOLO",
          "code": "47170"
        },
        {
          "name": "CIENAGA",
          "code": "47189"
        },
        {
          "name": "CONCORDIA",
          "code": "47205"
        },
        {
          "name": "EL BANCO",
          "code": "47245"
        },
        {
          "name": "EL PINON",
          "code": "47258"
        },
        {
          "name": "EL RETEN",
          "code": "47268"
        },
        {
          "name": "FUNDACION",
          "code": "47288"
        },
        {
          "name": "GUAMAL",
          "code": "47318"
        },
        {
          "name": "NUEVA GRANADA",
          "code": "47460"
        },
        {
          "name": "PEDRAZA",
          "code": "47541"
        },
        {
          "name": "PIJINO DEL CARMEN",
          "code": "47545"
        },
        {
          "name": "PIVIJAY",
          "code": "47551"
        },
        {
          "name": "PLATO",
          "code": "47555"
        },
        {
          "name": "PUEBLO VIEJO",
          "code": "47570"
        },
        {
          "name": "REMOLINO",
          "code": "47605"
        },
        {
          "name": "SABANAS DE SAN ANGEL",
          "code": "47660"
        },
        {
          "name": "SALAMINA",
          "code": "47675"
        },
        {
          "name": "SAN SEBASTIAN DE BUENAVISTA",
          "code": "47692"
        },
        {
          "name": "SAN ZENON",
          "code": "47703"
        },
        {
          "name": "SANTA ANA",
          "code": "47707"
        },
        {
          "name": "SANTA BARBARA DE PINTO",
          "code": "47720"
        },
        {
          "name": "SANTA MARTA",
          "code": "47001"
        },
        {
          "name": "SITIONUEVO",
          "code": "47745"
        },
        {
          "name": "TENERIFE",
          "code": "47798"
        },
        {
          "name": "ZAPAYAN",
          "code": "47960"
        },
        {
          "name": "ZONA BANANERA",
          "code": "47980"
        }
      ]
    },
    {
      "name": "META",
      "cities": [
        {
          "name": "ACACiAS",
          "code": "50006"
        },
        {
          "name": "BARRANCA DE UPIA",
          "code": "50110"
        },
        {
          "name": "CABUYARO",
          "code": "50124"
        },
        {
          "name": "CASTILLA LA NUEVA",
          "code": "50150"
        },
        {
          "name": "CUMARAL",
          "code": "50226"
        },
        {
          "name": "EL CALVARIO",
          "code": "50245"
        },
        {
          "name": "EL CASTILLO",
          "code": "50251"
        },
        {
          "name": "EL DORADO",
          "code": "50270"
        },
        {
          "name": "FUENTE DE ORO",
          "code": "50287"
        },
        {
          "name": "GRANADA",
          "code": "50313"
        },
        {
          "name": "GUAMAL",
          "code": "50318"
        },
        {
          "name": "LA MACARENA",
          "code": "50350"
        },
        {
          "name": "LA URIBE",
          "code": "50370"
        },
        {
          "name": "LEJANIAS",
          "code": "50400"
        },
        {
          "name": "MAPIRIPaN",
          "code": "50325"
        },
        {
          "name": "MESETAS",
          "code": "50330"
        },
        {
          "name": "PUERTO CONCORDIA",
          "code": "50450"
        },
        {
          "name": "PUERTO GAITAN",
          "code": "50568"
        },
        {
          "name": "PUERTO LLERAS",
          "code": "50577"
        },
        {
          "name": "PUERTO LoPEZ",
          "code": "50573"
        },
        {
          "name": "PUERTO RICO",
          "code": "50590"
        },
        {
          "name": "RESTREPO",
          "code": "50606"
        },
        {
          "name": "SAN CARLOS GUAROA",
          "code": "50680"
        },
        {
          "name": "SAN JUAN DE ARAMA",
          "code": "50683"
        },
        {
          "name": "SAN JUANITO",
          "code": "50686"
        },
        {
          "name": "SAN LUIS DE CUBARRAL",
          "code": "50223"
        },
        {
          "name": "SAN MARTIN",
          "code": "50689"
        },
        {
          "name": "VILLAVICENCIO",
          "code": "50001"
        },
        {
          "name": "VISTA HERMOSA",
          "code": "50711"
        }
      ]
    },
    {
      "name": "NARIÑO",
      "cities": [
        {
          "name": "ALBAN",
          "code": "52019"
        },
        {
          "name": "ALDANA",
          "code": "52022"
        },
        {
          "name": "ANCUYA",
          "code": "52036"
        },
        {
          "name": "ARBOLEDA",
          "code": "52051"
        },
        {
          "name": "BARBACOAS",
          "code": "52079"
        },
        {
          "name": "BELEN",
          "code": "52083"
        },
        {
          "name": "BUESACO",
          "code": "52110"
        },
        {
          "name": "CHACHAGUI",
          "code": "52240"
        },
        {
          "name": "COLON",
          "code": "52203"
        },
        {
          "name": "CONSACA",
          "code": "52207"
        },
        {
          "name": "CONTADERO",
          "code": "52210"
        },
        {
          "name": "CORDOBA",
          "code": "52215"
        },
        {
          "name": "CUASPUD",
          "code": "52224"
        },
        {
          "name": "CUMBAL",
          "code": "52227"
        },
        {
          "name": "CUMBITARA",
          "code": "52233"
        },
        {
          "name": "EL CHARCO",
          "code": "52250"
        },
        {
          "name": "EL PENOL",
          "code": "52254"
        },
        {
          "name": "EL ROSARIO",
          "code": "52256"
        },
        {
          "name": "El Tablon de Gomez",
          "code": "52258"
        },
        {
          "name": "EL TAMBO",
          "code": "52260"
        },
        {
          "name": "FRANCISCO PIZARRO",
          "code": "52520"
        },
        {
          "name": "FUNES",
          "code": "52287"
        },
        {
          "name": "GUACHUCAL",
          "code": "52317"
        },
        {
          "name": "GUAITARILLA",
          "code": "52320"
        },
        {
          "name": "GUALMATAN",
          "code": "52323"
        },
        {
          "name": "ILES",
          "code": "52352"
        },
        {
          "name": "IMUES",
          "code": "52354"
        },
        {
          "name": "IPIALES",
          "code": "52356"
        },
        {
          "name": "LA CRUZ",
          "code": "52378"
        },
        {
          "name": "LA FLORIDA",
          "code": "52381"
        },
        {
          "name": "LA LLANADA",
          "code": "52385"
        },
        {
          "name": "LA TOLA",
          "code": "52390"
        },
        {
          "name": "LA UNION",
          "code": "52399"
        },
        {
          "name": "LEIVA",
          "code": "52405"
        },
        {
          "name": "LINARES",
          "code": "52411"
        },
        {
          "name": "LOS ANDES",
          "code": "52418"
        },
        {
          "name": "Magui",
          "code": "52427"
        },
        {
          "name": "MALLAMA",
          "code": "52435"
        },
        {
          "name": "MOSQUERA",
          "code": "52473"
        },
        {
          "name": "NARINO",
          "code": "52480"
        },
        {
          "name": "OLAYA HERRERA",
          "code": "52490"
        },
        {
          "name": "OSPINA",
          "code": "52506"
        },
        {
          "name": "PASTO",
          "code": "52001"
        },
        {
          "name": "POLICARPA",
          "code": "52540"
        },
        {
          "name": "POTOSI",
          "code": "52560"
        },
        {
          "name": "PROVIDENCIA",
          "code": "52565"
        },
        {
          "name": "PUERRES",
          "code": "52573"
        },
        {
          "name": "PUPIALES",
          "code": "52585"
        },
        {
          "name": "RICAURTE",
          "code": "52612"
        },
        {
          "name": "ROBERTO PAYAN",
          "code": "52621"
        },
        {
          "name": "SAMANIEGO",
          "code": "52678"
        },
        {
          "name": "SAN BERNARDO",
          "code": "52685"
        },
        {
          "name": "SAN LORENZO",
          "code": "52687"
        },
        {
          "name": "SAN PABLO",
          "code": "52693"
        },
        {
          "name": "SAN PEDRO DE CARTAGO",
          "code": "52694"
        },
        {
          "name": "SANDONA",
          "code": "52683"
        },
        {
          "name": "SANTA BaRBARA",
          "code": "52696"
        },
        {
          "name": "SANTA CRUZ",
          "code": "52699"
        },
        {
          "name": "SAPUYES",
          "code": "52720"
        },
        {
          "name": "TAMINANGO",
          "code": "52786"
        },
        {
          "name": "TANGUA",
          "code": "52788"
        },
        {
          "name": "TUMACO",
          "code": "52835"
        },
        {
          "name": "TUQUERRES",
          "code": "52838"
        },
        {
          "name": "YACUANQUER",
          "code": "52885"
        }
      ]
    },
    {
      "name": "NORTE DE SANTANDER",
      "cities": [
        {
          "name": "ABREGO",
          "code": "54003"
        },
        {
          "name": "ARBOLEDAS",
          "code": "54051"
        },
        {
          "name": "BOCHALEMA",
          "code": "54099"
        },
        {
          "name": "BUCARASICA",
          "code": "54109"
        },
        {
          "name": "CACHIRA",
          "code": "54128"
        },
        {
          "name": "CACOTA",
          "code": "54125"
        },
        {
          "name": "CHINACOTA",
          "code": "54172"
        },
        {
          "name": "CHITAGA",
          "code": "54174"
        },
        {
          "name": "CONVENCION",
          "code": "54206"
        },
        {
          "name": "CUCUTA",
          "code": "54001"
        },
        {
          "name": "CUCUTILLA",
          "code": "54223"
        },
        {
          "name": "DURANIA",
          "code": "54239"
        },
        {
          "name": "EL CARMEN",
          "code": "54245"
        },
        {
          "name": "EL TARRA",
          "code": "54250"
        },
        {
          "name": "EL ZULIA",
          "code": "54261"
        },
        {
          "name": "GRAMALOTE",
          "code": "54313"
        },
        {
          "name": "HACARI",
          "code": "54344"
        },
        {
          "name": "HERRAN",
          "code": "54347"
        },
        {
          "name": "LA ESPERANZA",
          "code": "54385"
        },
        {
          "name": "LA PLAYA",
          "code": "54398"
        },
        {
          "name": "LABATECA",
          "code": "54377"
        },
        {
          "name": "LOS PATIOS",
          "code": "54405"
        },
        {
          "name": "LOURDES",
          "code": "54418"
        },
        {
          "name": "MUTISCUA",
          "code": "54480"
        },
        {
          "name": "OCANA",
          "code": "54498"
        },
        {
          "name": "PAMPLONA",
          "code": "54518"
        },
        {
          "name": "PAMPLONITA",
          "code": "54520"
        },
        {
          "name": "PUERTO SANTANDER",
          "code": "54553"
        },
        {
          "name": "RAGONVALIA",
          "code": "54599"
        },
        {
          "name": "SALAZAR",
          "code": "54660"
        },
        {
          "name": "SAN CALIXTO",
          "code": "54670"
        },
        {
          "name": "SAN CAYETANO",
          "code": "54673"
        },
        {
          "name": "SANTIAGO",
          "code": "54680"
        },
        {
          "name": "SARDINATA",
          "code": "54720"
        },
        {
          "name": "SILOS",
          "code": "54743"
        },
        {
          "name": "TEORAMA",
          "code": "54800"
        },
        {
          "name": "TIBU",
          "code": "54810"
        },
        {
          "name": "TOLEDO",
          "code": "54820"
        },
        {
          "name": "VILLA CARO",
          "code": "54871"
        },
        {
          "name": "VILLA DEL ROSARIO",
          "code": "54874"
        }
      ]
    },
    {
      "name": "PUTUMAYO",
      "cities": [
        {
          "name": "COLON",
          "code": "86219"
        },
        {
          "name": "MOCOA",
          "code": "86001"
        },
        {
          "name": "ORITO",
          "code": "86320"
        },
        {
          "name": "PUERTO ASIS",
          "code": "86568"
        },
        {
          "name": "PUERTO CAICEDO",
          "code": "86569"
        },
        {
          "name": "PUERTO GUZMAN",
          "code": "86571"
        },
        {
          "name": "PUERTO LEGUIZAMO",
          "code": "86573"
        },
        {
          "name": "SAN FRANCISCO",
          "code": "86755"
        },
        {
          "name": "SAN MIGUEL",
          "code": "86757"
        },
        {
          "name": "SANTIAGO",
          "code": "86760"
        },
        {
          "name": "SIBUNDOY",
          "code": "86749"
        },
        {
          "name": "VALLE DEL GUAMUEZ",
          "code": "86865"
        },
        {
          "name": "VILLA GARZON",
          "code": "86885"
        }
      ]
    },
    {
      "name": "QUINDIO",
      "cities": [
        {
          "name": "ARMENIA",
          "code": "63001"
        },
        {
          "name": "BUENAVISTA",
          "code": "63111"
        },
        {
          "name": "CALARCA",
          "code": "63130"
        },
        {
          "name": "CIRCASIA",
          "code": "63190"
        },
        {
          "name": "CoRDOBA",
          "code": "63212"
        },
        {
          "name": "FILANDIA",
          "code": "63272"
        },
        {
          "name": "GeNOVA",
          "code": "63302"
        },
        {
          "name": "LA TEBAIDA",
          "code": "63401"
        },
        {
          "name": "Montengro",
          "code": "63470"
        },
        {
          "name": "PIJAO",
          "code": "63548"
        },
        {
          "name": "QUIMBAYA",
          "code": "63594"
        },
        {
          "name": "SALENTO",
          "code": "63690"
        }
      ]
    },
    {
      "name": "RISARALDA",
      "cities": [
        {
          "name": "APIA",
          "code": "66045"
        },
        {
          "name": "BALBOA",
          "code": "66075"
        },
        {
          "name": "BELEN DE UMBRIA",
          "code": "66088"
        },
        {
          "name": "DOSQUEBRADAS",
          "code": "66170"
        },
        {
          "name": "GUATICA",
          "code": "66318"
        },
        {
          "name": "LA CELIA",
          "code": "66383"
        },
        {
          "name": "LA VIRGINIA",
          "code": "66400"
        },
        {
          "name": "MARSELLA",
          "code": "66440"
        },
        {
          "name": "MISTRATO",
          "code": "66456"
        },
        {
          "name": "PEREIRA",
          "code": "66001"
        },
        {
          "name": "PUEBLO RICO",
          "code": "66572"
        },
        {
          "name": "QUINCHiA",
          "code": "66594"
        },
        {
          "name": "SANTA ROSA DE CABAL",
          "code": "66682"
        },
        {
          "name": "SANTUARIO",
          "code": "66687"
        }
      ]
    },
    {
      "name": "SANTANDER",
      "cities": [
        {
          "name": "AGUADA",
          "code": "68013"
        },
        {
          "name": "ALBANIA",
          "code": "68020"
        },
        {
          "name": "ARATOCA",
          "code": "68051"
        },
        {
          "name": "BARBOSA",
          "code": "68077"
        },
        {
          "name": "BARICHARA",
          "code": "68079"
        },
        {
          "name": "BARRANCABERMEJA",
          "code": "68081"
        },
        {
          "name": "BETULIA",
          "code": "68092"
        },
        {
          "name": "BOLIVAR",
          "code": "68101"
        },
        {
          "name": "BUCARAMANGA",
          "code": "68001"
        },
        {
          "name": "CABRERA",
          "code": "68121"
        },
        {
          "name": "CALIFORNIA",
          "code": "68132"
        },
        {
          "name": "CAPITANEJO",
          "code": "68147"
        },
        {
          "name": "CARCASI",
          "code": "68152"
        },
        {
          "name": "CEPITA",
          "code": "68160"
        },
        {
          "name": "CERRITO",
          "code": "68162"
        },
        {
          "name": "CHARALA",
          "code": "68167"
        },
        {
          "name": "CHARTA",
          "code": "68169"
        },
        {
          "name": "CHIMA",
          "code": "68176"
        },
        {
          "name": "CHIPATA",
          "code": "68179"
        },
        {
          "name": "CIMITARRA",
          "code": "68190"
        },
        {
          "name": "CONCEPCION",
          "code": "68207"
        },
        {
          "name": "CONFINES",
          "code": "68209"
        },
        {
          "name": "CONTRATACION",
          "code": "68211"
        },
        {
          "name": "COROMORO",
          "code": "68217"
        },
        {
          "name": "CURITI",
          "code": "68229"
        },
        {
          "name": "EL CARMEN DE CHUCURI",
          "code": "68235"
        },
        {
          "name": "EL GUACAMAYO",
          "code": "68245"
        },
        {
          "name": "EL PENON",
          "code": "68250"
        },
        {
          "name": "EL PLAYON",
          "code": "68255"
        },
        {
          "name": "ENCINO",
          "code": "68264"
        },
        {
          "name": "ENCISO",
          "code": "68266"
        },
        {
          "name": "FLORIAN",
          "code": "68271"
        },
        {
          "name": "FLORIDABLANCA",
          "code": "68276"
        },
        {
          "name": "GALAN",
          "code": "68296"
        },
        {
          "name": "GAMBITA",
          "code": "68298"
        },
        {
          "name": "GIRON",
          "code": "68307"
        },
        {
          "name": "GUACA",
          "code": "68318"
        },
        {
          "name": "GUADALUPE",
          "code": "68320"
        },
        {
          "name": "GUAPOTA",
          "code": "68322"
        },
        {
          "name": "GUAVATA",
          "code": "68324"
        },
        {
          "name": "GuEPSA",
          "code": "68327"
        },
        {
          "name": "HATO",
          "code": "68344"
        },
        {
          "name": "JESUS MARIA",
          "code": "68368"
        },
        {
          "name": "JORDAN",
          "code": "68370"
        },
        {
          "name": "LA BELLEZA",
          "code": "68377"
        },
        {
          "name": "LA PAZ",
          "code": "68397"
        },
        {
          "name": "LANDAZURI",
          "code": "68385"
        },
        {
          "name": "LEBRIJA",
          "code": "68406"
        },
        {
          "name": "LOS SANTOS",
          "code": "68418"
        },
        {
          "name": "MACARAVITA",
          "code": "68425"
        },
        {
          "name": "MALAGA",
          "code": "68432"
        },
        {
          "name": "MATANZA",
          "code": "68444"
        },
        {
          "name": "MOGOTES",
          "code": "68464"
        },
        {
          "name": "MOLAGAVITA",
          "code": "68468"
        },
        {
          "name": "OCAMONTE",
          "code": "68498"
        },
        {
          "name": "OIBA",
          "code": "68500"
        },
        {
          "name": "ONZAGA",
          "code": "68502"
        },
        {
          "name": "PALMAR",
          "code": "68522"
        },
        {
          "name": "PALMAS DEL SOCORRO",
          "code": "68524"
        },
        {
          "name": "PARAMO",
          "code": "68533"
        },
        {
          "name": "PIEDECUESTA",
          "code": "68547"
        },
        {
          "name": "PINCHOTE",
          "code": "68549"
        },
        {
          "name": "PUENTE NACIONAL",
          "code": "68572"
        },
        {
          "name": "PUERTO PARRA",
          "code": "68573"
        },
        {
          "name": "PUERTO WILCHES",
          "code": "68575"
        },
        {
          "name": "RIONEGRO",
          "code": "68615"
        },
        {
          "name": "SABANA DE TORRES",
          "code": "68655"
        },
        {
          "name": "SAN ANDRES",
          "code": "68669"
        },
        {
          "name": "SAN BENITO",
          "code": "68673"
        },
        {
          "name": "SAN GIL",
          "code": "68679"
        },
        {
          "name": "SAN JOAQUIN",
          "code": "68682"
        },
        {
          "name": "SAN JOSE DE MIRANDA",
          "code": "68684"
        },
        {
          "name": "SAN MIGUEL",
          "code": "68686"
        },
        {
          "name": "SAN VICENTE DE CHUCURI",
          "code": "68689"
        },
        {
          "name": "SANTA BARBARA",
          "code": "68705"
        },
        {
          "name": "SANTA HELENA DEL OPON",
          "code": "68720"
        },
        {
          "name": "SIMACOTA",
          "code": "68745"
        },
        {
          "name": "SOCORRO",
          "code": "68755"
        },
        {
          "name": "SUAITA",
          "code": "68770"
        },
        {
          "name": "SUCRE",
          "code": "68773"
        },
        {
          "name": "SURATA",
          "code": "68780"
        },
        {
          "name": "TONA",
          "code": "68820"
        },
        {
          "name": "VALLE DE SAN JOSE",
          "code": "68855"
        },
        {
          "name": "VELEZ",
          "code": "68861"
        },
        {
          "name": "VETAS",
          "code": "68867"
        },
        {
          "name": "VILLANUEVA",
          "code": "68872"
        },
        {
          "name": "ZAPATOCA",
          "code": "68895"
        }
      ]
    },
    {
      "name": "SUCRE",
      "cities": [
        {
          "name": "BUENAVISTA",
          "code": "70110"
        },
        {
          "name": "CAIMITO",
          "code": "70124"
        },
        {
          "name": "CHALAN",
          "code": "70230"
        },
        {
          "name": "COLOSO",
          "code": "70204"
        },
        {
          "name": "COROZAL",
          "code": "70215"
        },
        {
          "name": "COVENAS",
          "code": "70221"
        },
        {
          "name": "EL ROBLE",
          "code": "70233"
        },
        {
          "name": "GALERAS",
          "code": "70235"
        },
        {
          "name": "GUARANDA",
          "code": "70265"
        },
        {
          "name": "LA UNION",
          "code": "70400"
        },
        {
          "name": "LOS PALMITOS",
          "code": "70418"
        },
        {
          "name": "MAJAGUAL",
          "code": "70429"
        },
        {
          "name": "MORROA",
          "code": "70473"
        },
        {
          "name": "OVEJAS",
          "code": "70508"
        },
        {
          "name": "PALMITO",
          "code": "70523"
        },
        {
          "name": "SAMPUES",
          "code": "70670"
        },
        {
          "name": "SAN BENITO ABAD",
          "code": "70678"
        },
        {
          "name": "SAN JUAN BETULIA",
          "code": "70702"
        },
        {
          "name": "SAN MARCOS",
          "code": "70708"
        },
        {
          "name": "SAN ONOFRE",
          "code": "70713"
        },
        {
          "name": "SAN PEDRO",
          "code": "70717"
        },
        {
          "name": "SANTIAGO DE TOLU",
          "code": "70820"
        },
        {
          "name": "SINCE",
          "code": "70742"
        },
        {
          "name": "SINCELEJO",
          "code": "70001"
        },
        {
          "name": "SUCRE",
          "code": "70771"
        },
        {
          "name": "TOLU VIEJO",
          "code": "70823"
        }
      ]
    },
    {
      "name": "TOLIMA",
      "cities": [
        {
          "name": "ALPUJARRA",
          "code": "73024"
        },
        {
          "name": "ALVARADO",
          "code": "73026"
        },
        {
          "name": "AMBALEMA",
          "code": "73030"
        },
        {
          "name": "ANZOATEGUI",
          "code": "73043"
        },
        {
          "name": "ARMERO",
          "code": "73055"
        },
        {
          "name": "ATACO",
          "code": "73067"
        },
        {
          "name": "CAJAMARCA",
          "code": "73124"
        },
        {
          "name": "CARMEN DE APICALA",
          "code": "73148"
        },
        {
          "name": "CASABIANCA",
          "code": "73152"
        },
        {
          "name": "CHAPARRAL",
          "code": "73168"
        },
        {
          "name": "COELLO",
          "code": "73200"
        },
        {
          "name": "COYAIMA",
          "code": "73217"
        },
        {
          "name": "CUNDAY",
          "code": "73226"
        },
        {
          "name": "DOLORES",
          "code": "73236"
        },
        {
          "name": "ESPINAL",
          "code": "73268"
        },
        {
          "name": "FALAN",
          "code": "73270"
        },
        {
          "name": "FLANDES",
          "code": "73275"
        },
        {
          "name": "FRESNO",
          "code": "73283"
        },
        {
          "name": "GUAMO",
          "code": "73319"
        },
        {
          "name": "HERVEO",
          "code": "73347"
        },
        {
          "name": "HONDA",
          "code": "73349"
        },
        {
          "name": "IBAGUe",
          "code": "73001"
        },
        {
          "name": "ICONONZO",
          "code": "73352"
        },
        {
          "name": "LeRIDA",
          "code": "73408"
        },
        {
          "name": "LiBANO",
          "code": "73411"
        },
        {
          "name": "MARIQUITA",
          "code": "73443"
        },
        {
          "name": "MELGAR",
          "code": "73449"
        },
        {
          "name": "MURILLO",
          "code": "73461"
        },
        {
          "name": "NATAGAIMA",
          "code": "73483"
        },
        {
          "name": "ORTEGA",
          "code": "73504"
        },
        {
          "name": "PALOCABILDO",
          "code": "73520"
        },
        {
          "name": "PIEDRAS",
          "code": "73547"
        },
        {
          "name": "PLANADAS",
          "code": "73555"
        },
        {
          "name": "PRADO",
          "code": "73563"
        },
        {
          "name": "PURIFICACION",
          "code": "73585"
        },
        {
          "name": "RIOBLANCO",
          "code": "73616"
        },
        {
          "name": "RONCESVALLES",
          "code": "73622"
        },
        {
          "name": "ROVIRA",
          "code": "73624"
        },
        {
          "name": "SALDANA",
          "code": "73671"
        },
        {
          "name": "SAN ANTONIO",
          "code": "73675"
        },
        {
          "name": "SAN LUIS",
          "code": "73678"
        },
        {
          "name": "SANTA ISABEL",
          "code": "73686"
        },
        {
          "name": "SUAREZ",
          "code": "73770"
        },
        {
          "name": "VALLE DE SAN JUAN",
          "code": "73854"
        },
        {
          "name": "VENADILLO",
          "code": "73861"
        },
        {
          "name": "VILLAHERMOSA",
          "code": "73870"
        },
        {
          "name": "VILLARRICA",
          "code": "73873"
        }
      ]
    },
    {
      "name": "VALLE DEL CAUCA",
      "cities": [
        {
          "name": "ALCALa",
          "code": "76020"
        },
        {
          "name": "ANDALUCIA",
          "code": "76036"
        },
        {
          "name": "ANSERMANUEVO",
          "code": "76041"
        },
        {
          "name": "ARGELIA",
          "code": "76054"
        },
        {
          "name": "BOLIVAR",
          "code": "76100"
        },
        {
          "name": "BUENAVENTURA",
          "code": "76109"
        },
        {
          "name": "BUGA",
          "code": "76111"
        },
        {
          "name": "BUGALAGRANDE",
          "code": "76113"
        },
        {
          "name": "CAICEDONIA",
          "code": "76122"
        },
        {
          "name": "CALI",
          "code": "76001"
        },
        {
          "name": "CALIMA",
          "code": "76126"
        },
        {
          "name": "CANDELARIA",
          "code": "76130"
        },
        {
          "name": "CARTAGO",
          "code": "76147"
        },
        {
          "name": "DAGUA",
          "code": "76233"
        },
        {
          "name": "EL AGUILA",
          "code": "76243"
        },
        {
          "name": "EL CAIRO",
          "code": "76246"
        },
        {
          "name": "EL CERRITO",
          "code": "76248"
        },
        {
          "name": "EL DOVIO",
          "code": "76250"
        },
        {
          "name": "FLORIDA",
          "code": "76275"
        },
        {
          "name": "GINEBRA",
          "code": "76306"
        },
        {
          "name": "GUACARI",
          "code": "76318"
        },
        {
          "name": "JAMUNDI",
          "code": "76364"
        },
        {
          "name": "LA CUMBRE",
          "code": "76377"
        },
        {
          "name": "LA UNION",
          "code": "76400"
        },
        {
          "name": "LA VICTORIA",
          "code": "76403"
        },
        {
          "name": "OBANDO",
          "code": "76497"
        },
        {
          "name": "PALMIRA",
          "code": "76520"
        },
        {
          "name": "PRADERA",
          "code": "76563"
        },
        {
          "name": "RESTREPO",
          "code": "76606"
        },
        {
          "name": "RIOFRIO",
          "code": "76616"
        },
        {
          "name": "ROLDANILLO",
          "code": "76622"
        },
        {
          "name": "SAN PEDRO",
          "code": "76670"
        },
        {
          "name": "SEVILLA",
          "code": "76736"
        },
        {
          "name": "TORO",
          "code": "76823"
        },
        {
          "name": "TRUJILLO",
          "code": "76828"
        },
        {
          "name": "TULUA",
          "code": "76834"
        },
        {
          "name": "ULLOA",
          "code": "76845"
        },
        {
          "name": "VERSALLES",
          "code": "76863"
        },
        {
          "name": "VIJES",
          "code": "76869"
        },
        {
          "name": "YOTOCO",
          "code": "76890"
        },
        {
          "name": "YUMBO",
          "code": "76892"
        },
        {
          "name": "ZARZAL",
          "code": "76895"
        }
      ]
    },
    {
      "name": "VAUPES",
      "cities": [
        {
          "name": "CARURU",
          "code": "97161"
        },
        {
          "name": "MITU",
          "code": "97001"
        },
        {
          "name": "PACOA",
          "code": "97511"
        },
        {
          "name": "PAPUNAHUA",
          "code": "97777"
        },
        {
          "name": "TARAIRA",
          "code": "97666"
        },
        {
          "name": "YAVARATE",
          "code": "97889"
        }
      ]
    },
    {
      "name": "VICHADA",
      "cities": [
        {
          "name": "CUMARIBO",
          "code": "99773"
        },
        {
          "name": "LA PRIMAVERA",
          "code": "99524"
        },
        {
          "name": "PUERTO CARRENO",
          "code": "99001"
        },
        {
          "name": "SANTA ROSALIA",
          "code": "99624"
        }
      ]
    }
  ];

  const COLOMBIA_DEPARTMENTS = _COLOMBIA_DEPARTMENTS_RAW.map((department) => ({
    ...department,
    cities: (department.cities || []).filter(
      (city) => city && city.code && !EXCLUDED_MUNICIPALITY_CODES.has(city.code)
    ),
  }));

  const COLOMBIA_DEPARTMENTS_BY_NAME = COLOMBIA_DEPARTMENTS.reduce((acc, department) => {
    if (department && department.name) {
      acc[department.name] = department;
    }
    return acc;
  }, {});

  window.COLOMBIA_DEPARTMENTS_DATA = {
    departments: COLOMBIA_DEPARTMENTS,
    departmentsByName: COLOMBIA_DEPARTMENTS_BY_NAME,
    departmentOptions: DEPARTMENT_OPTIONS,
    cityOptions: CITY_OPTIONS,
    departmentCodeMap: DEPARTMENT_CODE_MAP,
    excludedMunicipalityCodes: Array.from(EXCLUDED_MUNICIPALITY_CODES),
  };